var _g, _g2, _path, _g3, _path2, _g4, _path3, _path4, _g5, _path5, _g6, _path6, _g7, _path7, _path8, _path9, _g8, _path10, _g9, _g10, _path11, _g11, _g12, _path12, _g13, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g14, _path20, _path21, _path22, _path23, _g15, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g16, _path36, _path37, _path38, _path39, _g17, _path40, _path41, _path42, _path43, _path44, _g18, _path45, _g19, _g20, _path46, _g21, _path47, _path48, _g22, _path49, _path50, _g23, _path51, _path52, _g24, _path53, _path54, _g25, _path55, _path56, _g26, _path57, _path58, _g27, _path59, _path60, _g28, _path61, _path62, _g29, _path63, _path64, _g30, _path65, _path66, _g31, _g32, _path67, _g33, _path68, _g34, _path69, _g35, _path70, _g36, _path71, _g37, _path72, _g38, _path73, _g39, _path74, _g40, _path75, _path76, _path77, _path78, _path79, _path80, _g41, _path81, _path82, _path83, _path84, _path85, _g42, _path86, _g43, _g44, _path87, _g45, _path88, _g46, _path89, _g47, _g48, _path90, _g49, _path91, _g50, _g51, _g52, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _g53, _path102, _g54, _path103, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTopicSerpxray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 167,
    viewBox: "0 0 241 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.956 0.0447998H12.2871C5.50112 0.0447998 0 5.54592 0 12.3319V121.687C0 128.473 5.50112 133.974 12.2871 133.974H117.956C124.742 133.974 130.243 128.473 130.243 121.687V12.3319C130.243 5.54592 124.742 0.0447998 117.956 0.0447998Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.956 0.966331H12.287C6.01004 0.966331 0.921532 6.05484 0.921532 12.3318V121.687C0.921532 127.964 6.01004 133.052 12.287 133.052H117.956C124.233 133.052 129.322 127.964 129.322 121.687V12.3318C129.322 6.05484 124.233 0.966331 117.956 0.966331Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.328 53.6476L95.6103 53.7075C94.3828 53.7125 93.3865 52.7215 93.3851 51.494L93.3851 51.494C93.3836 50.2665 94.3775 49.2674 95.605 49.2624L110.322 49.2024C111.55 49.1974 112.546 50.1885 112.548 51.416C112.549 52.6435 111.555 53.6426 110.328 53.6476Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6092 52.7859L110.327 52.726C111.045 52.7231 111.627 52.1382 111.626 51.4196L111.626 51.4196C111.625 50.7011 111.042 50.121 110.323 50.1239L95.6061 50.1838C94.8875 50.1868 94.3057 50.7716 94.3066 51.4902L94.3066 51.4902C94.3074 52.2087 94.8906 52.7889 95.6092 52.7859Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.887 67.8569L95.6103 67.9313C94.3828 67.9363 93.3865 66.9453 93.3851 65.7178L93.3851 65.7178C93.3836 64.4903 94.3775 63.4912 95.605 63.4862L113.882 63.4118C115.109 63.4068 116.106 64.3978 116.107 65.6253C116.108 66.8528 115.115 67.8519 113.887 67.8569Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6092 67.0098L113.886 66.9354C114.605 66.9325 115.186 66.3476 115.186 65.629L115.186 65.629C115.185 64.9105 114.601 64.3304 113.883 64.3333L95.6061 64.4077C94.8875 64.4106 94.3057 64.9955 94.3066 65.7141L94.3066 65.7141C94.3074 66.4326 94.8906 67.0128 95.6092 67.0098Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.354 60.7152L95.6186 60.82C94.3911 60.825 93.3948 59.834 93.3934 58.6065L93.3934 58.6065C93.3919 57.379 94.3858 56.3799 95.6133 56.3749L121.349 56.2701C122.577 56.2651 123.573 57.2561 123.574 58.4836C123.576 59.7111 122.582 60.7102 121.354 60.7152Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6175 59.8985L121.353 59.7937C122.072 59.7908 122.654 59.2059 122.653 58.4874L122.653 58.4874C122.652 57.7688 122.069 57.1887 121.35 57.1916L95.6144 57.2964C94.8958 57.2994 94.314 57.8842 94.3149 58.6028L94.3149 58.6028C94.3157 59.3213 94.8989 59.9015 95.6175 59.8985Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1714 30.4719H41.9646L45.6227 26.1061L48.1674 29.934L50.4176 33.4429L51.9096 29.934H54.0521L56.1197 27.382L58.375 32.8049L59.867 27.063L61.3682 30.4719H66.1523L68.995 28.1951L73.9699 35.6758L76.6934 24.6174L80.366 33.3991L83.9195 30.4719H96.8354",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.8537 14.7374L44.1013 14.6898C43.2833 14.6886 42.618 15.3507 42.6153 16.1688C42.6127 16.9868 43.2737 17.651 44.0918 17.6522L75.8441 17.6998C76.6622 17.701 77.3275 17.0388 77.3301 16.2208C77.3327 15.4028 76.6717 14.7386 75.8537 14.7374Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0989 15.4304L75.8513 15.478C76.2603 15.4786 76.5908 15.8107 76.5895 16.2197L76.5895 16.2197C76.5882 16.6287 76.2556 16.9598 75.8465 16.9592L44.0942 16.9116C43.6852 16.911 43.3546 16.5789 43.356 16.1699L43.356 16.1699C43.3573 15.7609 43.6899 15.4298 44.0989 15.4304Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.4812
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.8298 10.0267L44.1165 9.94924C43.2985 9.94802 42.6332 10.6102 42.6305 11.4282C42.6279 12.2462 43.2889 12.9104 44.107 12.9116L95.8203 12.9891C96.6384 12.9903 97.3037 12.3282 97.3063 11.5101C97.3089 10.6921 96.6479 10.0279 95.8298 10.0267Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.114 10.6898L95.8274 10.7673C96.2364 10.7679 96.5669 11.1 96.5656 11.509L96.5656 11.509C96.5643 11.918 96.2316 12.2491 95.8226 12.2485L44.1093 12.171C43.7002 12.1704 43.3697 11.8383 43.371 11.4293L43.371 11.4293C43.3724 11.0203 43.705 10.6892 44.114 10.6898Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.4812
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8227 9.93766L36.1811 9.9382C38.308 9.94139 40.0267 11.6682 40.0198 13.7951C40.013 15.922 38.2832 17.6436 36.1563 17.6404L35.7979 17.6398C33.671 17.6367 31.9524 15.9099 31.9592 13.783C31.966 11.6561 33.6958 9.93448 35.8227 9.93766Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8198 10.8592L36.1782 10.8597C37.7961 10.8621 39.1035 12.1757 39.0983 13.7937C39.0931 15.4116 37.7773 16.7213 36.1593 16.7189L35.8009 16.7183C34.183 16.7159 32.8756 15.4023 32.8808 13.7844C32.886 12.1664 34.2018 10.8568 35.8198 10.8592Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5902 53.1498C22.5902 52.3356 21.9301 51.6755 21.1159 51.6755C20.3017 51.6755 19.6416 52.3356 19.6416 53.1498V66.9097C19.6416 67.7239 20.3017 68.384 21.1159 68.384C21.9301 68.384 22.5902 67.7239 22.5902 66.9097V53.1498Z",
    fill: "#8F8B8F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2346 58.5562C13.4204 58.5562 12.7603 59.2163 12.7603 60.0305C12.7603 60.8447 13.4204 61.5048 14.2346 61.5048H27.9945C28.8087 61.5048 29.4688 60.8447 29.4688 60.0305C29.4688 59.2163 28.8087 58.5562 27.9945 58.5562H14.2346Z",
    fill: "#8F8B8F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_1_2)"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6302 133.555C55.9743 132.062 46.8737 122.142 43.7629 108.612C40.0051 92.2693 46.4102 76.8473 58.0691 74.1666C63.8727 72.8322 69.884 74.9064 74.9218 79.3422C78.8785 78.6301 86.4874 82.796 93.4858 89.8199C101.73 98.094 106.005 107.201 103.034 110.16C100.556 112.629 93.8189 110.041 86.8672 104.311C87.5583 111.413 86.3531 118.073 83.6815 123.257C84.7845 125.606 85.6716 128.297 86.243 131.209C86.6502 133.283 86.8668 135.315 86.9095 137.249C87.8772 140.16 88.456 143.573 88.5034 147.228C88.643 157.994 84.1191 166.782 78.3989 166.856C72.6788 166.93 67.9285 158.263 67.7889 147.497C67.7656 145.699 67.8723 143.956 68.0929 142.3C67.1672 140.16 66.4183 137.765 65.9147 135.199C65.8065 134.648 65.7118 134.1 65.6302 133.555Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 73,
    width: 62,
    height: 94
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6302 133.555C55.9743 132.062 46.8737 122.142 43.7629 108.612C40.0051 92.2693 46.4102 76.8473 58.0691 74.1666C63.8727 72.8322 69.884 74.9064 74.9218 79.3422C78.8785 78.6301 86.4874 82.796 93.4858 89.8199C101.73 98.094 106.005 107.201 103.034 110.16C100.556 112.629 93.8189 110.041 86.8672 104.311C87.5583 111.413 86.3531 118.073 83.6815 123.257C84.7845 125.606 85.6716 128.297 86.243 131.209C86.6502 133.283 86.8668 135.315 86.9095 137.249C87.8772 140.16 88.456 143.573 88.5034 147.228C88.643 157.994 84.1191 166.782 78.3989 166.856C72.6788 166.93 67.9285 158.263 67.7889 147.497C67.7656 145.699 67.8723 143.956 68.0929 142.3C67.1672 140.16 66.4183 137.765 65.9147 135.199C65.8065 134.648 65.7118 134.1 65.6302 133.555Z",
    fill: "#8F8B8F"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7629 108.612L45.5591 108.199L43.7629 108.612ZM65.6302 133.555L67.4529 133.282L67.2518 131.941L65.9119 131.734L65.6302 133.555ZM58.0691 74.1666L57.6561 72.3704L58.0691 74.1666ZM74.9218 79.3422L73.7038 80.7255L74.372 81.3139L75.2483 81.1562L74.9218 79.3422ZM93.4858 89.8199L94.7914 88.5191L93.4858 89.8199ZM103.034 110.16L104.335 111.466L103.034 110.16ZM86.8672 104.311L88.0394 102.889L84.6012 100.055L85.0328 104.49L86.8672 104.311ZM83.6815 123.257L82.0432 122.413L81.6276 123.219L82.0132 124.04L83.6815 123.257ZM86.243 131.209L88.0516 130.854L86.243 131.209ZM86.9095 137.249L85.0669 137.289L85.073 137.567L85.1605 137.83L86.9095 137.249ZM88.5034 147.228L90.3463 147.204L88.5034 147.228ZM78.3989 166.856L78.375 165.013L78.3989 166.856ZM67.7889 147.497L65.946 147.52L67.7889 147.497ZM68.0929 142.3L69.9198 142.544L69.9873 142.037L69.7845 141.569L68.0929 142.3ZM65.9147 135.199L64.1061 135.554L65.9147 135.199ZM41.9667 109.025C45.1788 122.995 54.6875 133.728 65.3485 135.377L65.9119 131.734C57.2612 130.396 48.5687 121.289 45.5591 108.199L41.9667 109.025ZM57.6561 72.3704C51.095 73.879 46.1832 78.9365 43.4327 85.5592C40.6804 92.186 40.0118 100.523 41.9667 109.025L45.5591 108.199C43.7562 100.359 44.4113 92.8132 46.8369 86.973C49.2641 81.1287 53.3843 77.1349 58.4821 75.9628L57.6561 72.3704ZM76.1398 77.959C70.786 73.2449 64.1879 70.8686 57.6561 72.3704L58.4821 75.9628C63.5574 74.7959 68.9821 76.5679 73.7038 80.7255L76.1398 77.959ZM94.7914 88.5191C91.1937 84.9083 87.4083 81.9992 83.9631 80.0717C82.2407 79.108 80.569 78.3703 79.0211 77.9212C77.4932 77.4778 75.9683 77.2812 74.5953 77.5283L75.2483 81.1562C75.8536 81.0472 76.7636 81.1043 77.9939 81.4613C79.2042 81.8125 80.614 82.4217 82.1632 83.2885C85.2612 85.0218 88.7795 87.7077 92.1801 91.1208L94.7914 88.5191ZM104.335 111.466C105.608 110.197 105.927 108.44 105.792 106.75C105.656 105.05 105.05 103.152 104.134 101.2C102.294 97.281 99.0227 92.7659 94.7914 88.5191L92.1801 91.1208C96.1927 95.1481 99.1808 99.3233 100.797 102.766C101.609 104.495 102.03 105.946 102.118 107.044C102.206 108.153 101.945 108.643 101.733 108.855L104.335 111.466ZM85.695 105.733C89.271 108.681 92.8725 110.891 95.9912 112.04C97.5472 112.613 99.0735 112.956 100.466 112.937C101.869 112.917 103.276 112.522 104.335 111.466L101.733 108.855C101.554 109.034 101.189 109.24 100.415 109.251C99.6297 109.262 98.5725 109.062 97.2654 108.581C94.6581 107.62 91.4151 105.671 88.0394 102.889L85.695 105.733ZM85.3198 124.101C88.176 118.559 89.422 111.535 88.7016 104.133L85.0328 104.49C85.6946 111.29 84.5303 117.587 82.0432 122.413L85.3198 124.101ZM88.0516 130.854C87.4526 127.802 86.52 124.966 85.3498 122.474L82.0132 124.04C83.0489 126.246 83.8906 128.793 84.4345 131.564L88.0516 130.854ZM88.7521 137.208C88.707 135.166 88.4786 133.029 88.0516 130.854L84.4345 131.564C84.8218 133.537 85.0266 135.463 85.0669 137.289L88.7521 137.208ZM90.3463 147.204C90.2966 143.375 89.6907 139.772 88.6585 136.667L85.1605 137.83C86.0638 140.547 86.6154 143.771 86.6605 147.252L90.3463 147.204ZM78.4228 168.699C82.2985 168.649 85.337 165.683 87.2873 161.895C89.2794 158.025 90.4192 152.827 90.3463 147.204L86.6605 147.252C86.7272 152.395 85.6749 156.974 84.0099 160.208C82.303 163.523 80.2195 164.989 78.375 165.013L78.4228 168.699ZM65.946 147.52C66.0189 153.144 67.2932 158.31 69.385 162.127C71.4328 165.864 74.5472 168.749 78.4228 168.699L78.375 165.013C76.5305 165.037 74.4097 163.626 72.6175 160.356C70.8692 157.166 69.6985 152.615 69.6318 147.473L65.946 147.52ZM66.266 142.057C66.0334 143.803 65.9215 145.635 65.946 147.52L69.6318 147.473C69.6096 145.763 69.7112 144.11 69.9198 142.544L66.266 142.057ZM64.1061 135.554C64.6342 138.244 65.4213 140.766 66.4013 143.032L69.7845 141.569C68.9131 139.554 68.2025 137.285 67.7232 134.844L64.1061 135.554ZM63.8075 133.829C63.8932 134.4 63.9926 134.976 64.1061 135.554L67.7232 134.844C67.6204 134.32 67.5304 133.799 67.4529 133.282L63.8075 133.829Z",
    fill: "#8F8B8F"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0152 113.021C65.4675 114.753 67.2456 124.475 63.9866 134.737C63.4111 136.549 62.7171 138.257 61.9342 139.831C62.3613 142.102 62.5646 144.577 62.4973 147.163C62.217 157.926 57.3538 166.531 51.6351 166.382C45.9164 166.233 41.5077 157.387 41.7881 146.623C41.8516 144.182 42.151 141.851 42.6428 139.709C42.4739 136.33 42.9806 132.439 44.2421 128.467C47.5011 118.205 54.5629 111.289 60.0152 113.021Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 112,
    width: 25,
    height: 55
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0152 113.021C65.4675 114.753 67.2456 124.475 63.9866 134.737C63.4111 136.549 62.7171 138.257 61.9342 139.831C62.3613 142.102 62.5646 144.577 62.4973 147.163C62.217 157.926 57.3538 166.531 51.6351 166.382C45.9164 166.233 41.5077 157.387 41.7881 146.623C41.8516 144.182 42.151 141.851 42.6428 139.709C42.4739 136.33 42.9806 132.439 44.2421 128.467C47.5011 118.205 54.5629 111.289 60.0152 113.021Z",
    fill: "#8F8B8F"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9866 134.737L65.7432 135.295L63.9866 134.737ZM60.0152 113.021L60.5731 111.264L60.0152 113.021ZM61.9342 139.831L60.284 139.01L60.0086 139.564L60.1229 140.172L61.9342 139.831ZM62.4973 147.163L64.3397 147.211L62.4973 147.163ZM51.6351 166.382L51.5871 168.224L51.6351 166.382ZM41.7881 146.623L43.6305 146.671L41.7881 146.623ZM42.6428 139.709L44.4391 140.121L44.4963 139.872L44.4835 139.617L42.6428 139.709ZM44.2421 128.467L45.9987 129.025L44.2421 128.467ZM65.7432 135.295C67.4454 129.935 67.8636 124.63 67.0806 120.349C66.3141 116.157 64.2672 112.438 60.5731 111.264L59.4573 114.778C61.2155 115.336 62.7838 117.343 63.4546 121.012C64.109 124.59 63.7868 129.277 62.23 134.179L65.7432 135.295ZM63.5845 140.652C64.4103 138.991 65.1396 137.196 65.7432 135.295L62.23 134.179C61.6826 135.903 61.0239 137.523 60.284 139.01L63.5845 140.652ZM64.3397 147.211C64.4103 144.499 64.1976 141.894 63.7455 139.49L60.1229 140.172C60.525 142.31 60.7189 144.654 60.6548 147.115L64.3397 147.211ZM51.5871 168.224C55.4618 168.325 58.6136 165.481 60.7101 161.771C62.8516 157.982 64.1933 152.833 64.3397 147.211L60.6548 147.115C60.5209 152.256 59.2909 156.791 57.501 159.958C55.6662 163.204 53.5271 164.588 51.6831 164.539L51.5871 168.224ZM39.9456 146.575C39.7992 152.197 40.871 157.41 42.8124 161.305C44.7129 165.119 47.7125 168.123 51.5871 168.224L51.6831 164.539C49.8391 164.491 47.7749 162.999 46.1115 159.661C44.489 156.405 43.4966 151.813 43.6305 146.671L39.9456 146.575ZM40.8464 139.297C40.3264 141.563 40.0123 144.015 39.9456 146.575L43.6305 146.671C43.691 144.348 43.9757 142.14 44.4391 140.121L40.8464 139.297ZM42.4855 127.909C41.1647 132.068 40.6209 136.179 40.802 139.801L44.4835 139.617C44.3268 136.481 44.7965 132.81 45.9987 129.025L42.4855 127.909ZM60.5731 111.264C56.8789 110.091 53.061 111.948 50.0167 114.929C46.9069 117.975 44.1877 122.549 42.4855 127.909L45.9987 129.025C47.5555 124.123 49.9967 120.108 52.5957 117.563C55.2601 114.954 57.6992 114.219 59.4573 114.778L60.5731 111.264Z",
    fill: "#8F8B8F"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_1_2)"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7484 134.113H42.1605C42.4179 132.863 42.7486 131.591 43.155 130.311C44.2032 127.01 45.632 124.045 47.2728 121.579C45.706 118.889 44.3964 115.894 43.4218 112.663C36.8875 119.069 30.4849 122.204 27.4672 119.938C23.4491 116.921 26.9532 105.471 35.2938 94.3645C38.6333 89.9176 42.2417 86.1999 45.6264 83.5341C46.2074 82.5265 46.8455 81.5803 47.5372 80.7034C40.0953 72.2678 40.0247 59.4049 47.7561 50.8733C56.0603 41.7097 70.2208 41.013 79.3845 49.3172C88.3459 57.4381 89.21 71.1598 81.4772 80.3317C82.3663 80.8591 83.17 81.5152 83.8626 82.2743C87.0935 84.1654 90.6465 86.933 94.0591 90.358C102.581 98.9111 107 108.325 103.93 111.385C101.368 113.937 94.4029 111.261 87.2165 105.337C87.9314 112.679 86.6856 119.565 83.9235 124.925C85.0635 127.353 85.9804 130.135 86.571 133.144C86.6346 133.468 86.6937 133.791 86.7484 134.113Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 43,
    width: 80,
    height: 92
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7484 134.113H42.1605C42.4179 132.863 42.7486 131.591 43.155 130.311C44.2032 127.01 45.632 124.045 47.2728 121.579C45.706 118.889 44.3964 115.894 43.4218 112.663C36.8875 119.069 30.4849 122.204 27.4672 119.938C23.4491 116.921 26.9532 105.471 35.2938 94.3645C38.6333 89.9176 42.2417 86.1999 45.6264 83.5341C46.2074 82.5265 46.8455 81.5803 47.5372 80.7034C40.0953 72.2678 40.0247 59.4049 47.7561 50.8733C56.0603 41.7097 70.2208 41.013 79.3845 49.3172C88.3459 57.4381 89.21 71.1598 81.4772 80.3317C82.3663 80.8591 83.17 81.5152 83.8626 82.2743C87.0935 84.1654 90.6465 86.933 94.0591 90.358C102.581 98.9111 107 108.325 103.93 111.385C101.368 113.937 94.4029 111.261 87.2165 105.337C87.9314 112.679 86.6856 119.565 83.9235 124.925C85.0635 127.353 85.9804 130.135 86.571 133.144C86.6346 133.468 86.6937 133.791 86.7484 134.113Z",
    fill: "#8F8B8F"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7484 134.113V135.956H88.9309L88.5654 133.804L86.7484 134.113ZM42.1605 134.113L40.3553 133.741L39.8994 135.956H42.1605V134.113ZM43.155 130.311L41.3984 129.753L43.155 130.311ZM47.2728 121.579L48.8072 122.6L49.4434 121.644L48.8654 120.651L47.2728 121.579ZM43.4218 112.663L45.1864 112.131L44.3067 109.214L42.1315 111.347L43.4218 112.663ZM27.4672 119.938L26.3604 121.412L27.4672 119.938ZM35.2938 94.3645L36.7676 95.4712L35.2938 94.3645ZM45.6264 83.5341L46.7668 84.982L47.0456 84.7624L47.223 84.4549L45.6264 83.5341ZM47.5372 80.7034L48.9842 81.8448L49.9367 80.6373L48.9193 79.4841L47.5372 80.7034ZM47.7561 50.8733L49.1218 52.1109L47.7561 50.8733ZM79.3845 49.3172L80.6221 47.9515L79.3845 49.3172ZM81.4772 80.3317L80.0681 79.1437L78.6658 80.807L80.5369 81.9169L81.4772 80.3317ZM83.8626 82.2743L82.5011 83.5166L82.6899 83.7235L82.9316 83.8649L83.8626 82.2743ZM94.0591 90.358L95.3647 89.0572L94.0591 90.358ZM103.93 111.385L102.629 110.079L103.93 111.385ZM87.2165 105.337L88.3887 103.915L84.9502 101.081L85.3821 105.516L87.2165 105.337ZM83.9235 124.925L82.2852 124.081L81.8696 124.887L82.2552 125.708L83.9235 124.925ZM86.571 133.144L84.7625 133.499L86.571 133.144ZM86.7484 132.27H42.1605V135.956H86.7484V132.27ZM41.3984 129.753C40.9727 131.094 40.6257 132.428 40.3553 133.741L43.9658 134.485C44.21 133.298 44.5244 132.088 44.9116 130.869L41.3984 129.753ZM45.7384 120.558C43.9961 123.176 42.4952 126.3 41.3984 129.753L44.9116 130.869C45.9112 127.721 47.2679 124.913 48.8072 122.6L45.7384 120.558ZM41.6573 113.195C42.6725 116.561 44.0392 119.689 45.6801 122.507L48.8654 120.651C47.3729 118.089 46.1202 115.227 45.1864 112.131L41.6573 113.195ZM26.3604 121.412C28.747 123.204 31.9975 122.577 34.9038 121.224C37.9529 119.804 41.357 117.269 44.7121 113.979L42.1315 111.347C38.9524 114.464 35.888 116.699 33.3478 117.882C30.6648 119.131 29.2051 118.938 28.5739 118.464L26.3604 121.412ZM33.82 93.2578C29.5559 98.936 26.4774 104.764 24.9836 109.645C24.2392 112.078 23.8573 114.375 23.9827 116.348C24.1076 118.312 24.7617 120.211 26.3604 121.412L28.5739 118.464C28.1636 118.156 27.749 117.492 27.6614 116.114C27.5744 114.745 27.8365 112.919 28.5084 110.724C29.8473 106.349 32.6911 100.9 36.7676 95.4712L33.82 93.2578ZM44.486 82.0862C40.9576 84.8653 37.2403 88.7033 33.82 93.2578L36.7676 95.4712C40.0263 91.1319 43.5259 87.5346 46.7668 84.982L44.486 82.0862ZM46.0901 79.5619C45.3405 80.5122 44.653 81.5327 44.0298 82.6134L47.223 84.4549C47.7619 83.5203 48.3504 82.6483 48.9842 81.8448L46.0901 79.5619ZM46.3904 49.6357C38.0218 58.8705 38.0994 72.7913 46.1551 81.9226L48.9193 79.4841C42.0913 71.7444 42.0276 59.9394 49.1218 52.1109L46.3904 49.6357ZM80.6221 47.9515C70.7042 38.9637 55.3781 39.7178 46.3904 49.6357L49.1218 52.1109C56.7425 43.7016 69.7375 43.0622 78.1468 50.6829L80.6221 47.9515ZM82.8863 81.5197C91.2563 71.5919 90.3214 56.7411 80.6221 47.9515L78.1468 50.6829C86.3704 58.1351 87.1636 70.7277 80.0681 79.1437L82.8863 81.5197ZM85.2241 81.032C84.4095 80.1393 83.4641 79.3674 82.4175 78.7466L80.5369 81.9169C81.2684 82.3508 81.9304 82.8911 82.5011 83.5166L85.2241 81.032ZM95.3647 89.0572C91.8579 85.5376 88.1814 82.6666 84.7936 80.6837L82.9316 83.8649C86.0056 85.6642 89.4351 88.3284 92.7534 91.6589L95.3647 89.0572ZM105.23 112.69C106.529 111.397 106.857 109.601 106.718 107.864C106.579 106.117 105.955 104.162 105.01 102.148C103.112 98.1052 99.735 93.4435 95.3647 89.0572L92.7534 91.6589C96.9051 95.8257 99.9987 100.148 101.673 103.715C102.514 105.506 102.952 107.012 103.044 108.158C103.136 109.314 102.866 109.843 102.629 110.079L105.23 112.69ZM86.0442 106.76C89.7376 109.804 93.4548 112.084 96.6702 113.269C98.2745 113.86 99.8444 114.212 101.273 114.192C102.714 114.172 104.15 113.767 105.23 112.69L102.629 110.079C102.428 110.279 102.033 110.495 101.223 110.506C100.401 110.518 99.2999 110.309 97.9445 109.81C95.2403 108.814 91.8818 106.794 88.3887 103.915L86.0442 106.76ZM85.5618 125.769C88.5085 120.051 89.7951 112.802 89.0508 105.159L85.3821 105.516C86.0677 112.557 84.8627 119.079 82.2852 124.081L85.5618 125.769ZM88.3796 132.789C87.7614 129.639 86.799 126.713 85.5918 124.142L82.2552 125.708C83.3279 127.993 84.1994 130.63 84.7625 133.499L88.3796 132.789ZM88.5654 133.804C88.5081 133.467 88.4462 133.129 88.3796 132.789L84.7625 133.499C84.8231 133.808 84.8793 134.115 84.9314 134.422L88.5654 133.804Z",
    fill: "#8F8B8F"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1764 111.236C34.1703 111.13 34.0839 111.057 33.9834 111.073C33.8829 111.088 33.8064 111.187 33.8125 111.293L34.02 114.893C34.0261 114.999 34.1125 115.073 34.213 115.057C34.3135 115.041 34.39 114.943 34.3839 114.837L34.1764 111.236Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.376277
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9634 111.613C32.9792 111.493 32.8983 111.393 32.7827 111.389C32.667 111.385 32.5605 111.478 32.5446 111.598L32.0066 115.668C31.9908 115.788 32.0717 115.888 32.1873 115.892C32.303 115.896 32.4095 115.803 32.4254 115.683L32.9634 111.613Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.42812
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7406 111.386C31.7875 111.273 31.7331 111.159 31.6191 111.133C31.505 111.106 31.3746 111.176 31.3277 111.289L29.4812 115.745C29.4343 115.859 29.4888 115.972 29.6028 115.999C29.7168 116.026 29.8473 115.956 29.8942 115.843L31.7406 111.386Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.433904
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4462 110.853C30.5093 110.751 30.4785 110.624 30.3774 110.569C30.2762 110.514 30.143 110.552 30.0799 110.654L28.1245 113.812C28.0614 113.914 28.0922 114.041 28.1933 114.096C28.2945 114.151 28.4277 114.112 28.4908 114.01L30.4462 110.853Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.425402
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5299 108.819C30.6326 108.76 30.6717 108.631 30.6174 108.53C30.5631 108.43 30.4358 108.397 30.3332 108.457L27.804 109.921C27.7014 109.981 27.6622 110.11 27.7166 110.21C27.7709 110.31 27.8982 110.343 28.0008 110.284L30.5299 108.819Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.420904
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2054 110.665C33.0154 110.958 33.8713 110.414 34.1172 109.449C34.3632 108.485 33.9059 107.466 33.096 107.173C32.286 106.88 31.4301 107.424 31.1842 108.389C30.9382 109.353 31.3955 110.372 32.2054 110.665Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 107,
    width: 4,
    height: 4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2054 110.665C33.0154 110.958 33.8713 110.414 34.1172 109.449C34.3632 108.485 33.9059 107.466 33.096 107.173C32.286 106.88 31.4301 107.424 31.1842 108.389C30.9382 109.353 31.3955 110.372 32.2054 110.665Z",
    fill: "#8F8B8F"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3839 108.823C32.3666 108.891 32.3387 108.9 32.3602 108.886C32.3724 108.879 32.4045 108.862 32.4593 108.855C32.5168 108.848 32.588 108.853 32.6608 108.88L31.75 112.451C33.7439 113.172 35.4171 111.776 35.8505 110.076L32.3839 108.823ZM32.6608 108.88C32.7336 108.906 32.7953 108.948 32.8398 108.993C32.8821 109.035 32.9009 109.07 32.9075 109.084C32.9189 109.11 32.9001 109.084 32.9174 109.016L29.4508 107.763C29.0174 109.462 29.756 111.731 31.75 112.451L32.6608 108.88ZM32.9174 109.016C32.9347 108.948 32.9626 108.939 32.9411 108.952C32.9289 108.96 32.8968 108.977 32.842 108.984C32.7845 108.991 32.7133 108.985 32.6405 108.959L33.5514 105.387C31.5574 104.666 29.8842 106.063 29.4508 107.763L32.9174 109.016ZM32.6405 108.959C32.5677 108.933 32.506 108.89 32.4615 108.846C32.4192 108.804 32.4004 108.769 32.3939 108.754C32.3824 108.729 32.4012 108.755 32.3839 108.823L35.8505 110.076C36.2839 108.377 35.5453 106.108 33.5514 105.387L32.6405 108.959Z",
    fill: "#8F8B8F"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7861 101.71L41.3322 101.034L33.2796 108.695L33.7334 109.372L41.7861 101.71Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.778768
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8993 99.9023L39.366 99.2577L32.0316 107.86L32.565 108.505L39.8993 99.9023Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.803556
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.64 101.722C41.9398 102.192 43.1672 101.892 43.3814 101.052C43.5956 100.212 42.7155 99.1501 41.4156 98.6802C40.1158 98.2103 38.8884 98.5102 38.6742 99.3502C38.46 100.19 39.3401 101.252 40.64 101.722Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 98,
    width: 6,
    height: 4
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.64 101.722C41.9398 102.192 43.1672 101.892 43.3814 101.052C43.5956 100.212 42.7155 99.1501 41.4156 98.6802C40.1158 98.2103 38.8884 98.5102 38.6742 99.3502C38.46 100.19 39.3401 101.252 40.64 101.722Z",
    fill: "#8F8B8F"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6481 100.425C41.6968 100.234 41.7965 100.115 41.8632 100.059C41.9216 100.01 41.9423 100.018 41.8828 100.032C41.7556 100.063 41.4714 100.072 41.0954 99.936L40.1845 103.508C41.1084 103.842 42.0878 103.935 42.9529 103.724C43.7904 103.519 44.7946 102.934 45.1147 101.679L41.6481 100.425ZM41.0954 99.936C40.7194 99.8001 40.4872 99.6047 40.396 99.4948C40.3533 99.4433 40.3742 99.4505 40.3998 99.53C40.4291 99.6206 40.4562 99.7858 40.4075 99.9769L36.9409 98.7237C36.6209 99.9787 37.1821 101.13 37.7826 101.855C38.4029 102.603 39.2607 103.174 40.1845 103.508L41.0954 99.936ZM40.4075 99.9769C40.3587 100.168 40.2591 100.287 40.1924 100.343C40.134 100.392 40.1133 100.385 40.1728 100.37C40.2999 100.339 40.5842 100.33 40.9602 100.466L41.871 96.8944C40.9471 96.5604 39.9678 96.4668 39.1027 96.6782C38.2652 96.8829 37.2609 97.4687 36.9409 98.7237L40.4075 99.9769ZM40.9602 100.466C41.3362 100.602 41.5684 100.798 41.6596 100.907C41.7023 100.959 41.6814 100.952 41.6558 100.872C41.6265 100.782 41.5994 100.616 41.6481 100.425L45.1147 101.679C45.4347 100.424 44.8735 99.2718 44.273 98.5473C43.6527 97.7989 42.7949 97.2284 41.871 96.8944L40.9602 100.466Z",
    fill: "#8F8B8F"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.415 86.1901C49.8482 86.0542 49.3312 86.3575 49.2603 86.8675C49.1894 87.3775 49.5914 87.9012 50.1582 88.0371C50.725 88.173 51.242 87.8697 51.3129 87.3597C51.3838 86.8497 50.9818 86.326 50.415 86.1901Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6147 96.9642C43.0479 96.8283 42.5309 97.1316 42.46 97.6416C42.3891 98.1516 42.7911 98.6753 43.3579 98.8112C43.9247 98.9471 44.4417 98.6438 44.5126 98.1338C44.5835 97.6238 44.1815 97.1001 43.6147 96.9642Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6836 85.2971C47.9751 85.1272 47.3288 85.5063 47.2402 86.1439C47.1516 86.7814 47.6541 87.436 48.3626 87.6059C49.0711 87.7758 49.7174 87.3967 49.806 86.7591C49.8946 86.1216 49.3921 85.467 48.6836 85.2971Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8823 96.0721C41.1738 95.9022 40.5275 96.2813 40.4389 96.9189C40.3503 97.5564 40.8528 98.211 41.5613 98.3809C42.2698 98.5508 42.9161 98.1717 43.0047 97.5341C43.0933 96.8966 42.5908 96.242 41.8823 96.0721Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9249 96.8866L43.1489 98.3251L50.3166 87.7042L48.0927 86.2658L40.9249 96.8866Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.83534
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6138 104.106C94.6018 104.015 94.6637 103.943 94.7521 103.946C94.8404 103.95 94.9217 104.027 94.9336 104.119L95.4097 107.774C95.4216 107.866 95.3597 107.938 95.2714 107.934C95.1831 107.931 95.1018 107.854 95.0898 107.762L94.6138 104.106Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.327413
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0632 104.23C96.0276 104.115 96.0906 104.002 96.2039 103.979C96.3172 103.956 96.438 104.03 96.4736 104.146L97.6845 108.069C97.7201 108.184 97.6571 108.297 97.5438 108.32C97.4305 108.343 97.3097 108.268 97.2741 108.153L96.0632 104.23Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.428121
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2308 103.806C97.1656 103.703 97.2003 103.581 97.3082 103.536C97.4161 103.49 97.5565 103.538 97.6216 103.641L100.187 107.726C100.252 107.83 100.218 107.951 100.11 107.997C100.002 108.042 99.8614 107.995 99.7962 107.891L97.2308 103.806Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.433904
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4188 103.065C98.3395 102.975 98.3486 102.845 98.4392 102.774C98.5298 102.703 98.6675 102.718 98.7468 102.808L101.203 105.595C101.282 105.685 101.273 105.815 101.182 105.886C101.092 105.957 100.954 105.942 100.875 105.852L98.4188 103.065Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.425402
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4929 101.072C97.3817 101.03 97.3215 100.909 97.3583 100.802C97.3952 100.694 97.5151 100.64 97.6263 100.681L100.365 101.703C100.476 101.744 100.536 101.865 100.499 101.973C100.462 102.081 100.342 102.134 100.231 102.093L97.4929 101.072Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.420904
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9778 102.983C95.4102 103.305 94.6709 102.936 94.3267 102.161C93.9825 101.385 94.1637 100.496 94.7314 100.175C95.2991 99.8534 96.0383 100.222 96.3825 100.997C96.7267 101.773 96.5455 102.662 95.9778 102.983Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 100,
    width: 3,
    height: 4
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9778 102.983C95.4102 103.305 94.6709 102.936 94.3267 102.161C93.9825 101.385 94.1637 100.496 94.7314 100.175C95.2991 99.8534 96.0383 100.222 96.3825 100.997C96.7267 101.773 96.5455 102.662 95.9778 102.983Z",
    fill: "#8F8B8F"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.9308 101.253C95.9525 101.302 95.961 101.275 95.8847 101.237C95.8064 101.198 95.5477 101.119 95.2303 101.299L96.7255 104.668C95.8403 105.169 94.9282 105.066 94.2522 104.729C93.5784 104.394 93.0452 103.795 92.7226 103.068L95.9308 101.253ZM95.2303 101.299C94.9128 101.478 94.8139 101.759 94.7947 101.854C94.776 101.945 94.8 101.954 94.7784 101.905L97.9867 100.09C98.3092 100.817 98.4147 101.657 98.2496 102.468C98.0839 103.281 97.6106 104.167 96.7255 104.668L95.2303 101.299ZM94.7784 101.905C94.7568 101.856 94.7483 101.883 94.8245 101.921C94.9028 101.96 95.1615 102.039 95.479 101.859L93.9838 98.4898C94.8689 97.989 95.7811 98.0915 96.457 98.4284C97.1308 98.7642 97.6641 99.3629 97.9867 100.09L94.7784 101.905ZM95.479 101.859C95.7964 101.679 95.8953 101.398 95.9145 101.304C95.9332 101.212 95.9092 101.204 95.9308 101.253L92.7226 103.068C92.4 102.341 92.2945 101.5 92.4597 100.69C92.6253 99.8769 93.0986 98.9906 93.9838 98.4898L95.479 101.859Z",
    fill: "#8F8B8F"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2274 96.4804L87.4619 95.8758L94.8508 101.462L94.6162 102.067L87.2274 96.4804Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.620672
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3619 94.7929L88.662 94.2068L95.6677 100.655L95.3676 101.241L88.3619 94.7929Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 0.632757
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1088 96.3876C87.1977 96.9031 86.2161 96.7733 85.9163 96.0977C85.6166 95.4221 86.1121 94.4566 87.0232 93.9412C87.9342 93.4257 88.9159 93.5555 89.2156 94.2311C89.5154 94.9067 89.0199 95.8722 88.1088 96.3876Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 93,
    width: 5,
    height: 4
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1088 96.3876C87.1977 96.9031 86.2161 96.7733 85.9163 96.0977C85.6166 95.4221 86.1121 94.4566 87.0232 93.9412C87.9342 93.4257 88.9159 93.5555 89.2156 94.2311C89.5154 94.9067 89.0199 95.8722 88.1088 96.3876Z",
    fill: "#8F8B8F"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5205 95.1902C87.4478 95.0263 87.3408 94.9174 87.2492 94.8563C87.1638 94.7992 87.104 94.7905 87.0979 94.7897C87.0942 94.7892 87.1975 94.7957 87.3613 94.703L88.8564 98.0723C88.1092 98.4951 87.2661 98.6944 86.4689 98.589C85.6772 98.4843 84.7701 98.0371 84.3123 97.0053L87.5205 95.1902ZM87.3613 94.703C87.5251 94.6104 87.5823 94.5131 87.5804 94.5167C87.5773 94.5227 87.5477 94.582 87.537 94.6934C87.5256 94.8128 87.5388 94.9748 87.6115 95.1387L90.8198 93.3236C91.2777 94.3554 91.0519 95.4435 90.6523 96.2222C90.2498 97.0063 89.6037 97.6495 88.8564 98.0723L87.3613 94.703ZM87.6115 95.1387C87.6843 95.3026 87.7913 95.4115 87.8828 95.4726C87.9683 95.5297 88.028 95.5384 88.0341 95.5392C88.0378 95.5397 87.9346 95.5332 87.7708 95.6259L86.2756 92.2566C87.0229 91.8338 87.866 91.6345 88.6632 91.7399C89.4549 91.8446 90.3619 92.2918 90.8198 93.3236L87.6115 95.1387ZM87.7708 95.6259C87.607 95.7185 87.5498 95.8158 87.5517 95.8122C87.5547 95.8062 87.5843 95.7469 87.595 95.6354C87.6064 95.5161 87.5933 95.3541 87.5205 95.1902L84.3123 97.0053C83.8544 95.9735 84.0801 94.8854 84.4798 94.1067C84.8823 93.3226 85.5283 92.6794 86.2756 92.2566L87.7708 95.6259Z",
    fill: "#8F8B8F"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M80.33 83.9862C80.0614 84.4459 80.1254 84.9483 80.473 85.1084C80.8207 85.2686 81.3202 85.0257 81.5888 84.566C81.8574 84.1063 81.7934 83.6039 81.4458 83.4438C81.0981 83.2836 80.5986 83.5265 80.33 83.9862Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M86.081 91.916C85.8124 92.3757 85.8764 92.8781 86.224 93.0383C86.5717 93.1984 87.0712 92.9555 87.3398 92.4958C87.6084 92.0361 87.5444 91.5337 87.1968 91.3736C86.8491 91.2135 86.3496 91.4563 86.081 91.916Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1367 84.2115C78.6008 85.1285 78.7286 86.1308 79.4221 86.4502C80.1155 86.7696 81.1121 86.2851 81.6479 85.3681C82.1837 84.4511 82.056 83.4488 81.3625 83.1294C80.6691 82.81 79.6725 83.2945 79.1367 84.2115Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9151 93.2273C84.5794 93.8019 84.6594 94.43 85.0939 94.6301C85.5285 94.8303 86.1529 94.5267 86.4887 93.9521C86.8244 93.3775 86.7444 92.7494 86.3098 92.5493C85.8753 92.3491 85.2509 92.6527 84.9151 93.2273Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2181 94.2077L86.9268 92.5803L81.398 84.365L79.6893 85.9925L85.2181 94.2077Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.82655
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5126 87.1778C69.4946 87.6023 69.9173 87.962 70.4107 87.9121C72.3229 87.719 74.1891 87.1395 75.8399 86.2204C77.5035 85.2941 78.8867 84.0571 79.8682 82.6258C80.1088 82.2748 79.8926 81.8202 79.4354 81.664C79.0395 81.5287 78.6026 81.6683 78.3952 81.9729C77.5592 83.2005 76.3763 84.2613 74.9519 85.0544C73.5311 85.8455 71.9226 86.3409 70.2758 86.4994C69.8577 86.5397 69.5278 86.8184 69.5126 87.1778Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 81,
    width: 11,
    height: 7
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5126 87.1778C69.4946 87.6023 69.9173 87.962 70.4107 87.9121C72.3229 87.719 74.1891 87.1395 75.8399 86.2204C77.5035 85.2941 78.8867 84.0571 79.8682 82.6258C80.1088 82.2748 79.8926 81.8202 79.4354 81.664C79.0395 81.5287 78.6026 81.6683 78.3952 81.9729C77.5592 83.2005 76.3763 84.2613 74.9519 85.0544C73.5311 85.8455 71.9226 86.3409 70.2758 86.4994C69.8577 86.5397 69.5278 86.8184 69.5126 87.1778Z",
    fill: "#8F8B8F"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.8399 86.2204L76.9722 87.6467L75.8399 86.2204ZM78.3952 81.9729L76.6687 81.0804L78.3952 81.9729ZM79.8682 82.6258L81.5918 83.5223L79.8682 82.6258ZM70.7234 89.5909C72.9393 89.3671 75.0842 88.6979 76.9722 87.6467L74.7075 84.794C73.2941 85.581 71.7066 86.0709 70.098 86.2334L70.7234 89.5909ZM76.9722 87.6467C78.8748 86.5874 80.4616 85.1706 81.5918 83.5223L78.1445 81.7292C77.3118 82.9437 76.1321 84.0008 74.7075 84.794L76.9722 87.6467ZM76.6687 81.0804C75.9817 82.0893 75.0035 82.9688 73.8195 83.628L76.0842 86.4807C77.7491 85.5537 79.1366 84.3117 80.1216 82.8653L76.6687 81.0804ZM73.8195 83.628C72.6386 84.2855 71.3127 84.6907 69.9737 84.8197L70.5779 88.1792C72.5325 87.991 74.4235 87.4054 76.0842 86.4807L73.8195 83.628ZM80.1083 80.0986C78.727 79.6266 77.3117 80.1363 76.6687 81.0804L80.1216 82.8653C79.8935 83.2003 79.352 83.4308 78.7626 83.2294L80.1083 80.0986ZM81.5918 83.5223C82.4908 82.2112 81.6302 80.6187 80.1083 80.0986L78.7626 83.2294C78.1549 83.0218 77.7268 82.3384 78.1445 81.7292L81.5918 83.5223ZM69.9737 84.8197C68.7001 84.9423 67.5823 85.8084 67.5299 87.0479L71.4954 87.3077C71.4733 87.8285 71.0153 88.1371 70.5779 88.1792L69.9737 84.8197ZM70.098 86.2334C70.9442 86.1479 71.5184 86.7637 71.4954 87.3077L67.5299 87.0479C67.4709 88.4408 68.8903 89.776 70.7234 89.5909L70.098 86.2334Z",
    fill: "#8F8B8F"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8884 87.1227C59.9494 87.5431 59.5655 87.9439 59.0696 87.9444C57.1476 87.9465 55.2322 87.5596 53.4967 86.8129C51.7476 86.0604 50.2458 84.9703 49.1241 83.6461C48.849 83.3214 49.018 82.8472 49.4569 82.6454C49.837 82.4705 50.2858 82.565 50.5231 82.8469C51.4795 83.9833 52.764 84.9184 54.2616 85.5628C55.7555 86.2054 57.4059 86.5349 59.0603 86.5254C59.4803 86.5229 59.8368 86.7667 59.8884 87.1227Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 82,
    width: 12,
    height: 6
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8884 87.1227C59.9494 87.5431 59.5655 87.9439 59.0696 87.9444C57.1476 87.9465 55.2322 87.5596 53.4967 86.8129C51.7476 86.0604 50.2458 84.9703 49.1241 83.6461C48.849 83.3214 49.018 82.8472 49.4569 82.6454C49.837 82.4705 50.2858 82.565 50.5231 82.8469C51.4795 83.9833 52.764 84.9184 54.2616 85.5628C55.7555 86.2054 57.4059 86.5349 59.0603 86.5254C59.4803 86.5229 59.8368 86.7667 59.8884 87.1227Z",
    fill: "#8F8B8F"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4967 86.8129L52.5151 88.3469L53.4967 86.8129ZM50.5231 82.8469L52.15 81.7838L50.5231 82.8469ZM49.1241 83.6461L47.5004 84.7131L49.1241 83.6461ZM58.929 89.6463C56.7019 89.6487 54.5001 89.2009 52.5151 88.3469L54.4783 85.2789C55.9644 85.9183 57.5934 86.2444 59.2101 86.2426L58.929 89.6463ZM52.5151 88.3469C50.5147 87.4863 48.7922 86.238 47.5004 84.7131L50.7477 82.5791C51.6995 83.7027 52.9805 84.6345 54.4783 85.2789L52.5151 88.3469ZM52.15 81.7838C52.9359 82.7176 53.9984 83.4932 55.2432 84.0288L53.28 87.0968C51.5295 86.3437 50.0231 85.249 48.8962 83.9101L52.15 81.7838ZM55.2432 84.0288C56.4848 84.5629 57.8451 84.8313 59.1902 84.8236L58.9304 88.2272C56.9668 88.2385 55.0261 87.848 53.28 87.0968L55.2432 84.0288ZM48.6285 81.1564C49.9547 80.5465 51.4145 80.9099 52.15 81.7838L48.8962 83.9101C49.1572 84.2202 49.7193 84.3946 50.2852 84.1343L48.6285 81.1564ZM47.5004 84.7131C46.4729 83.5001 47.1673 81.8284 48.6285 81.1564L50.2852 84.1343C50.8687 83.866 51.2252 83.1427 50.7477 82.5791L47.5004 84.7131ZM59.1902 84.8236C60.4696 84.8162 61.6696 85.5643 61.8478 86.7921L57.9291 87.4533C58.004 87.9692 58.491 88.2297 58.9304 88.2272L59.1902 84.8236ZM59.2101 86.2426C58.3596 86.2435 57.851 86.9145 57.9291 87.4533L61.8478 86.7921C62.0479 88.1718 60.7714 89.6442 58.929 89.6463L59.2101 86.2426Z",
    fill: "#8F8B8F"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3414 93.3138C60.518 93.7906 60.2789 94.3146 59.8009 94.4323C57.885 94.9039 55.855 94.8857 53.8962 94.3725C51.9339 93.8583 50.1158 92.8666 48.6056 91.494C48.2334 91.1557 48.2421 90.5761 48.5979 90.2399C48.9422 89.9145 49.4834 89.9398 49.8464 90.2639C51.1173 91.3989 52.6383 92.2201 54.2775 92.6495C55.9155 93.0787 57.6119 93.1011 59.2173 92.7208C59.6785 92.6116 60.1714 92.8549 60.3414 93.3138Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 90,
    width: 13,
    height: 5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3414 93.3138C60.518 93.7906 60.2789 94.3146 59.8009 94.4323C57.885 94.9039 55.855 94.8857 53.8962 94.3725C51.9339 93.8583 50.1158 92.8666 48.6056 91.494C48.2334 91.1557 48.2421 90.5761 48.5979 90.2399C48.9422 89.9145 49.4834 89.9398 49.8464 90.2639C51.1173 91.3989 52.6383 92.2201 54.2775 92.6495C55.9155 93.0787 57.6119 93.1011 59.2173 92.7208C59.6785 92.6116 60.1714 92.8549 60.3414 93.3138Z",
    fill: "#8F8B8F"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8464 90.2639L51.0258 88.8775L49.8464 90.2639ZM48.6056 91.494L49.7975 90.1187L48.6056 91.494ZM60.2746 96.2429C58.069 96.7858 55.7365 96.7639 53.4888 96.175L54.3036 92.5699C55.9735 93.0074 57.701 93.022 59.3272 92.6217L60.2746 96.2429ZM53.4888 96.175C51.2371 95.5851 49.1496 94.4469 47.4137 92.8692L49.7975 90.1187C51.082 91.2862 52.6307 92.1316 54.3036 92.5699L53.4888 96.175ZM51.0258 88.8775C52.0737 89.8132 53.3298 90.4919 54.6849 90.8469L53.87 94.4521C51.9467 93.9482 50.1609 92.9845 48.6669 91.6504L51.0258 88.8775ZM54.6849 90.8469C56.0389 91.2017 57.4383 91.2193 58.7587 90.9066L59.676 94.5351C57.7855 94.9828 55.792 94.9557 53.87 94.4521L54.6849 90.8469ZM47.3389 88.8576C48.4249 87.8314 50.024 87.9828 51.0258 88.8775L48.6669 91.6504C48.9428 91.8968 49.4594 91.9977 49.8568 91.6221L47.3389 88.8576ZM47.4137 92.8692C46.1574 91.7274 46.2707 89.8669 47.3389 88.8576L49.8568 91.6221C50.2134 91.2852 50.3094 90.584 49.7975 90.1187L47.4137 92.8692ZM58.7587 90.9066C60.0263 90.6064 61.5106 91.2539 62.0455 92.6979L58.6374 93.9298C58.8322 94.4558 59.3307 94.6169 59.676 94.5351L58.7587 90.9066ZM59.3272 92.6217C58.6719 92.783 58.4621 93.4567 58.6374 93.9298L62.0455 92.6979C62.5739 94.1245 61.886 95.8463 60.2746 96.2429L59.3272 92.6217Z",
    fill: "#8F8B8F"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3414 96.7967C60.518 97.2735 60.2789 97.7975 59.8009 97.9152C57.885 98.3868 55.855 98.3686 53.8962 97.8554C51.9339 97.3412 50.1158 96.3495 48.6056 94.9769C48.2334 94.6386 48.2421 94.059 48.5979 93.7228C48.9422 93.3974 49.4834 93.4227 49.8464 93.7468C51.1173 94.8818 52.6383 95.703 54.2775 96.1325C55.9155 96.5616 57.6119 96.584 59.2173 96.2038C59.6785 96.0945 60.1714 96.3378 60.3414 96.7967Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 93,
    width: 13,
    height: 6
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3414 96.7967C60.518 97.2735 60.2789 97.7975 59.8009 97.9152C57.885 98.3868 55.855 98.3686 53.8962 97.8554C51.9339 97.3412 50.1158 96.3495 48.6056 94.9769C48.2334 94.6386 48.2421 94.059 48.5979 93.7228C48.9422 93.3974 49.4834 93.4227 49.8464 93.7468C51.1173 94.8818 52.6383 95.703 54.2775 96.1325C55.9155 96.5616 57.6119 96.584 59.2173 96.2038C59.6785 96.0945 60.1714 96.3378 60.3414 96.7967Z",
    fill: "#8F8B8F"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8464 93.7468L51.0258 92.3604L49.8464 93.7468ZM48.6056 94.9769L49.7975 93.6016L48.6056 94.9769ZM60.2746 99.7258C58.069 100.269 55.7365 100.247 53.4888 99.658L54.3036 96.0528C55.9735 96.4903 57.701 96.5049 59.3272 96.1046L60.2746 99.7258ZM53.4888 99.658C51.2371 99.068 49.1496 97.9298 47.4137 96.3521L49.7975 93.6016C51.082 94.7691 52.6307 95.6145 54.3036 96.0528L53.4888 99.658ZM51.0258 92.3604C52.0737 93.2961 53.3298 93.9748 54.6849 94.3299L53.87 97.935C51.9467 97.4312 50.1609 96.4674 48.6669 95.1333L51.0258 92.3604ZM54.6849 94.3299C56.0389 94.6846 57.4383 94.7022 58.7587 94.3895L59.676 98.018C57.7855 98.4658 55.792 98.4386 53.87 97.935L54.6849 94.3299ZM47.3389 92.3405C48.4249 91.3143 50.024 91.4657 51.0258 92.3604L48.6669 95.1333C48.9428 95.3797 49.4594 95.4806 49.8568 95.105L47.3389 92.3405ZM47.4137 96.3521C46.1574 95.2103 46.2707 93.3499 47.3389 92.3405L49.8568 95.105C50.2134 94.7681 50.3094 94.0669 49.7975 93.6016L47.4137 96.3521ZM58.7587 94.3895C60.0263 94.0893 61.5106 94.7368 62.0455 96.1808L58.6374 97.4127C58.8322 97.9387 59.3307 98.0998 59.676 98.018L58.7587 94.3895ZM59.3272 96.1046C58.6719 96.2659 58.4621 96.9396 58.6374 97.4127L62.0455 96.1808C62.5739 97.6074 61.886 99.3292 60.2746 99.7258L59.3272 96.1046Z",
    fill: "#8F8B8F"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3414 100.281C60.518 100.758 60.2789 101.282 59.8009 101.399C57.885 101.871 55.855 101.853 53.8962 101.339C51.9339 100.825 50.1158 99.8336 48.6056 98.461C48.2334 98.1227 48.2421 97.5431 48.5979 97.2069C48.9422 96.8816 49.4834 96.9068 49.8464 97.231C51.1173 98.3659 52.6383 99.1871 54.2775 99.6166C55.9155 100.046 57.6119 100.068 59.2173 99.6879C59.6785 99.5787 60.1714 99.8219 60.3414 100.281Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 96,
    width: 13,
    height: 6
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3414 100.281C60.518 100.758 60.2789 101.282 59.8009 101.399C57.885 101.871 55.855 101.853 53.8962 101.339C51.9339 100.825 50.1158 99.8336 48.6056 98.461C48.2334 98.1227 48.2421 97.5431 48.5979 97.2069C48.9422 96.8816 49.4834 96.9068 49.8464 97.231C51.1173 98.3659 52.6383 99.1871 54.2775 99.6166C55.9155 100.046 57.6119 100.068 59.2173 99.6879C59.6785 99.5787 60.1714 99.8219 60.3414 100.281Z",
    fill: "#8F8B8F"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8464 97.231L51.0258 95.8445L49.8464 97.231ZM48.6056 98.461L49.7975 97.0858L48.6056 98.461ZM60.2746 103.21C58.069 103.753 55.7365 103.731 53.4888 103.142L54.3036 99.5369C55.9735 99.9744 57.701 99.989 59.3272 99.5887L60.2746 103.21ZM53.4888 103.142C51.2371 102.552 49.1496 101.414 47.4137 99.8362L49.7975 97.0858C51.082 98.2533 52.6307 99.0986 54.3036 99.5369L53.4888 103.142ZM51.0258 95.8445C52.0737 96.7803 53.3298 97.459 54.6849 97.814L53.87 101.419C51.9467 100.915 50.1609 99.9516 48.6669 98.6174L51.0258 95.8445ZM54.6849 97.814C56.0389 98.1688 57.4383 98.1863 58.7587 97.8736L59.676 101.502C57.7855 101.95 55.792 101.923 53.87 101.419L54.6849 97.814ZM47.3389 95.8247C48.4249 94.7984 50.024 94.9498 51.0258 95.8445L48.6669 98.6174C48.9428 98.8638 49.4594 98.9647 49.8568 98.5892L47.3389 95.8247ZM47.4137 99.8362C46.1574 98.6944 46.2707 96.834 47.3389 95.8247L49.8568 98.5892C50.2134 98.2523 50.3094 97.551 49.7975 97.0858L47.4137 99.8362ZM58.7587 97.8736C60.0263 97.5734 61.5106 98.221 62.0455 99.6649L58.6374 100.897C58.8322 101.423 59.3307 101.584 59.676 101.502L58.7587 97.8736ZM59.3272 99.5887C58.6719 99.75 58.4621 100.424 58.6374 100.897L62.0455 99.6649C62.5739 101.092 61.886 102.813 60.2746 103.21L59.3272 99.5887Z",
    fill: "#8F8B8F"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3414 103.764C60.518 104.241 60.2789 104.765 59.8009 104.882C57.885 105.354 55.855 105.336 53.8962 104.823C51.9339 104.308 50.1158 103.317 48.6056 101.944C48.2334 101.606 48.2421 101.026 48.5979 100.69C48.9422 100.365 49.4834 100.39 49.8464 100.714C51.1173 101.849 52.6383 102.67 54.2775 103.1C55.9155 103.529 57.6119 103.551 59.2173 103.171C59.6785 103.062 60.1714 103.305 60.3414 103.764Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 100,
    width: 13,
    height: 6
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3414 103.764C60.518 104.241 60.2789 104.765 59.8009 104.882C57.885 105.354 55.855 105.336 53.8962 104.823C51.9339 104.308 50.1158 103.317 48.6056 101.944C48.2334 101.606 48.2421 101.026 48.5979 100.69C48.9422 100.365 49.4834 100.39 49.8464 100.714C51.1173 101.849 52.6383 102.67 54.2775 103.1C55.9155 103.529 57.6119 103.551 59.2173 103.171C59.6785 103.062 60.1714 103.305 60.3414 103.764Z",
    fill: "#8F8B8F"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8464 100.714L51.0258 99.3275L49.8464 100.714ZM48.6056 101.944L49.7975 100.569L48.6056 101.944ZM60.2746 106.693C58.069 107.236 55.7365 107.214 53.4888 106.625L54.3036 103.02C55.9735 103.457 57.701 103.472 59.3272 103.072L60.2746 106.693ZM53.4888 106.625C51.2371 106.035 49.1496 104.897 47.4137 103.319L49.7975 100.569C51.082 101.736 52.6307 102.582 54.3036 103.02L53.4888 106.625ZM51.0258 99.3275C52.0737 100.263 53.3298 100.942 54.6849 101.297L53.87 104.902C51.9467 104.398 50.1609 103.435 48.6669 102.1L51.0258 99.3275ZM54.6849 101.297C56.0389 101.652 57.4383 101.669 58.7587 101.357L59.676 104.985C57.7855 105.433 55.792 105.406 53.87 104.902L54.6849 101.297ZM47.3389 99.3077C48.4249 98.2814 50.024 98.4329 51.0258 99.3275L48.6669 102.1C48.9428 102.347 49.4594 102.448 49.8568 102.072L47.3389 99.3077ZM47.4137 103.319C46.1574 102.177 46.2707 100.317 47.3389 99.3077L49.8568 102.072C50.2134 101.735 50.3094 101.034 49.7975 100.569L47.4137 103.319ZM58.7587 101.357C60.0263 101.056 61.5106 101.704 62.0455 103.148L58.6374 104.38C58.8322 104.906 59.3307 105.067 59.676 104.985L58.7587 101.357ZM59.3272 103.072C58.6719 103.233 58.4621 103.907 58.6374 104.38L62.0455 103.148C62.5739 104.575 61.886 106.296 60.2746 106.693L59.3272 103.072Z",
    fill: "#8F8B8F"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3414 107.249C60.518 107.726 60.2789 108.25 59.8009 108.367C57.885 108.839 55.855 108.821 53.8962 108.308C51.9339 107.793 50.1158 106.802 48.6056 105.429C48.2334 105.091 48.2421 104.511 48.5979 104.175C48.9422 103.85 49.4834 103.875 49.8464 104.199C51.1173 105.334 52.6383 106.155 54.2775 106.585C55.9155 107.014 57.6119 107.036 59.2173 106.656C59.6785 106.547 60.1714 106.79 60.3414 107.249Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 103,
    width: 13,
    height: 6
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3414 107.249C60.518 107.726 60.2789 108.25 59.8009 108.367C57.885 108.839 55.855 108.821 53.8962 108.308C51.9339 107.793 50.1158 106.802 48.6056 105.429C48.2334 105.091 48.2421 104.511 48.5979 104.175C48.9422 103.85 49.4834 103.875 49.8464 104.199C51.1173 105.334 52.6383 106.155 54.2775 106.585C55.9155 107.014 57.6119 107.036 59.2173 106.656C59.6785 106.547 60.1714 106.79 60.3414 107.249Z",
    fill: "#8F8B8F"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8464 104.199L51.0258 102.813L49.8464 104.199ZM48.6056 105.429L49.7975 104.054L48.6056 105.429ZM60.2746 110.178C58.069 110.721 55.7365 110.699 53.4888 110.11L54.3036 106.505C55.9735 106.942 57.701 106.957 59.3272 106.557L60.2746 110.178ZM53.4888 110.11C51.2371 109.52 49.1496 108.382 47.4137 106.804L49.7975 104.054C51.082 105.221 52.6307 106.067 54.3036 106.505L53.4888 110.11ZM51.0258 102.813C52.0737 103.748 53.3298 104.427 54.6849 104.782L53.87 108.387C51.9467 107.883 50.1609 106.92 48.6669 105.585L51.0258 102.813ZM54.6849 104.782C56.0389 105.137 57.4383 105.154 58.7587 104.842L59.676 108.47C57.7855 108.918 55.792 108.891 53.87 108.387L54.6849 104.782ZM47.3389 102.793C48.4249 101.766 50.024 101.918 51.0258 102.813L48.6669 105.585C48.9428 105.832 49.4594 105.933 49.8568 105.557L47.3389 102.793ZM47.4137 106.804C46.1574 105.662 46.2707 103.802 47.3389 102.793L49.8568 105.557C50.2134 105.22 50.3094 104.519 49.7975 104.054L47.4137 106.804ZM58.7587 104.842C60.0263 104.541 61.5106 105.189 62.0455 106.633L58.6374 107.865C58.8322 108.391 59.3307 108.552 59.676 108.47L58.7587 104.842ZM59.3272 106.557C58.6719 106.718 58.4621 107.392 58.6374 107.865L62.0455 106.633C62.5739 108.06 61.886 109.781 60.2746 110.178L59.3272 106.557Z",
    fill: "#8F8B8F"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8368 93.3147C68.6602 93.7915 68.8993 94.3155 69.3773 94.4331C71.2932 94.9047 73.3232 94.8865 75.282 94.3733C77.2443 93.8592 79.0624 92.8674 80.5726 91.4948C80.9448 91.1565 80.9362 90.5769 80.5804 90.2407C80.2361 89.9154 79.6948 89.9406 79.3318 90.2648C78.0609 91.3997 76.54 92.2209 74.9008 92.6504C73.2628 93.0796 71.5663 93.1019 69.9609 92.7217C69.4997 92.6125 69.0068 92.8557 68.8368 93.3147Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 90,
    width: 13,
    height: 5
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8368 93.3147C68.6602 93.7915 68.8993 94.3155 69.3773 94.4331C71.2932 94.9047 73.3232 94.8865 75.282 94.3733C77.2443 93.8592 79.0624 92.8674 80.5726 91.4948C80.9448 91.1565 80.9362 90.5769 80.5804 90.2407C80.2361 89.9154 79.6948 89.9406 79.3318 90.2648C78.0609 91.3997 76.54 92.2209 74.9008 92.6504C73.2628 93.0796 71.5663 93.1019 69.9609 92.7217C69.4997 92.6125 69.0068 92.8557 68.8368 93.3147Z",
    fill: "#8F8B8F"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3318 90.2648L78.1524 88.8783L79.3318 90.2648ZM80.5726 91.4948L79.3807 90.1196L80.5726 91.4948ZM68.9036 96.2438C71.1092 96.7867 73.4417 96.7648 75.6895 96.1759L74.8746 92.5707C73.2047 93.0082 71.4773 93.0228 69.851 92.6225L68.9036 96.2438ZM75.6895 96.1759C77.9411 95.586 80.0286 94.4478 81.7645 92.8701L79.3807 90.1196C78.0962 91.2871 76.5475 92.1324 74.8746 92.5707L75.6895 96.1759ZM78.1524 88.8783C77.1045 89.8141 75.8485 90.4928 74.4934 90.8478L75.3082 94.453C77.2315 93.9491 79.0173 92.9854 80.5113 91.6512L78.1524 88.8783ZM74.4934 90.8478C73.1393 91.2026 71.7399 91.2202 70.4196 90.9074L69.5022 94.5359C71.3927 94.9837 73.3863 94.9565 75.3082 94.453L74.4934 90.8478ZM81.8394 88.8585C80.7533 87.8322 79.1543 87.9836 78.1524 88.8783L80.5113 91.6512C80.2354 91.8976 79.7188 91.9985 79.3214 91.623L81.8394 88.8585ZM81.7645 92.8701C83.0208 91.7282 82.9075 89.8678 81.8394 88.8585L79.3214 91.623C78.9648 91.2861 78.8688 90.5848 79.3807 90.1196L81.7645 92.8701ZM70.4196 90.9074C69.1519 90.6072 67.6676 91.2548 67.1327 92.6988L70.5409 93.9306C70.346 94.4567 69.8475 94.6177 69.5022 94.5359L70.4196 90.9074ZM69.851 92.6225C70.5064 92.7838 70.7161 93.4575 70.5409 93.9306L67.1327 92.6988C66.6043 94.1254 67.2922 95.8471 68.9036 96.2438L69.851 92.6225Z",
    fill: "#8F8B8F"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8368 96.7977C68.6602 97.2745 68.8993 97.7985 69.3773 97.9162C71.2932 98.3878 73.3232 98.3695 75.282 97.8563C77.2443 97.3422 79.0624 96.3504 80.5726 94.9778C80.9448 94.6396 80.9362 94.06 80.5804 93.7238C80.2361 93.3984 79.6948 93.4237 79.3318 93.7478C78.0609 94.8828 76.54 95.704 74.9008 96.1334C73.2628 96.5626 71.5663 96.585 69.9609 96.2047C69.4997 96.0955 69.0068 96.3388 68.8368 96.7977Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 93,
    width: 13,
    height: 6
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8368 96.7977C68.6602 97.2745 68.8993 97.7985 69.3773 97.9162C71.2932 98.3878 73.3232 98.3695 75.282 97.8563C77.2443 97.3422 79.0624 96.3504 80.5726 94.9778C80.9448 94.6396 80.9362 94.06 80.5804 93.7238C80.2361 93.3984 79.6948 93.4237 79.3318 93.7478C78.0609 94.8828 76.54 95.704 74.9008 96.1334C73.2628 96.5626 71.5663 96.585 69.9609 96.2047C69.4997 96.0955 69.0068 96.3388 68.8368 96.7977Z",
    fill: "#8F8B8F"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3318 93.7478L78.1524 92.3614L79.3318 93.7478ZM80.5726 94.9778L79.3807 93.6026L80.5726 94.9778ZM68.9036 99.7268C71.1092 100.27 73.4417 100.248 75.6895 99.6589L74.8746 96.0537C73.2047 96.4913 71.4773 96.5058 69.851 96.1055L68.9036 99.7268ZM75.6895 99.6589C77.9411 99.069 80.0286 97.9308 81.7645 96.3531L79.3807 93.6026C78.0962 94.7701 76.5475 95.6154 74.8746 96.0537L75.6895 99.6589ZM78.1524 92.3614C77.1045 93.2971 75.8485 93.9758 74.4934 94.3308L75.3082 97.936C77.2315 97.4321 79.0173 96.4684 80.5113 95.1342L78.1524 92.3614ZM74.4934 94.3308C73.1393 94.6856 71.7399 94.7032 70.4196 94.3905L69.5022 98.019C71.3927 98.4667 73.3863 98.4396 75.3082 97.936L74.4934 94.3308ZM81.8394 92.3415C80.7533 91.3153 79.1543 91.4667 78.1524 92.3614L80.5113 95.1342C80.2354 95.3806 79.7188 95.4816 79.3214 95.106L81.8394 92.3415ZM81.7645 96.3531C83.0208 95.2113 82.9075 93.3508 81.8394 92.3415L79.3214 95.106C78.9648 94.7691 78.8688 94.0678 79.3807 93.6026L81.7645 96.3531ZM70.4196 94.3905C69.1519 94.0902 67.6676 94.7378 67.1327 96.1818L70.5409 97.4136C70.346 97.9397 69.8475 98.1008 69.5022 98.019L70.4196 94.3905ZM69.851 96.1055C70.5064 96.2669 70.7161 96.9406 70.5409 97.4136L67.1327 96.1818C66.6043 97.6084 67.2922 99.3301 68.9036 99.7268L69.851 96.1055Z",
    fill: "#8F8B8F"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8368 100.282C68.6602 100.759 68.8993 101.283 69.3773 101.4C71.2932 101.872 73.3232 101.854 75.282 101.34C77.2443 100.826 79.0624 99.8346 80.5726 98.462C80.9448 98.1237 80.9362 97.5441 80.5804 97.2079C80.2361 96.8825 79.6948 96.9078 79.3318 97.2319C78.0609 98.3669 76.54 99.1881 74.9008 99.6176C73.2628 100.047 71.5663 100.069 69.9609 99.6889C69.4997 99.5796 69.0068 99.8229 68.8368 100.282Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 96,
    width: 13,
    height: 6
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8368 100.282C68.6602 100.759 68.8993 101.283 69.3773 101.4C71.2932 101.872 73.3232 101.854 75.282 101.34C77.2443 100.826 79.0624 99.8346 80.5726 98.462C80.9448 98.1237 80.9362 97.5441 80.5804 97.2079C80.2361 96.8825 79.6948 96.9078 79.3318 97.2319C78.0609 98.3669 76.54 99.1881 74.9008 99.6176C73.2628 100.047 71.5663 100.069 69.9609 99.6889C69.4997 99.5796 69.0068 99.8229 68.8368 100.282Z",
    fill: "#8F8B8F"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3318 97.2319L78.1524 95.8455L79.3318 97.2319ZM80.5726 98.462L79.3807 97.0867L80.5726 98.462ZM68.9036 103.211C71.1092 103.754 73.4417 103.732 75.6895 103.143L74.8746 99.5379C73.2047 99.9754 71.4773 99.99 69.851 99.5897L68.9036 103.211ZM75.6895 103.143C77.9411 102.553 80.0286 101.415 81.7645 99.8372L79.3807 97.0867C78.0962 98.2542 76.5475 99.0996 74.8746 99.5379L75.6895 103.143ZM78.1524 95.8455C77.1045 96.7812 75.8485 97.4599 74.4934 97.815L75.3082 101.42C77.2315 100.916 79.0173 99.9525 80.5113 98.6184L78.1524 95.8455ZM74.4934 97.815C73.1393 98.1697 71.7399 98.1873 70.4196 97.8746L69.5022 101.503C71.3927 101.951 73.3863 101.924 75.3082 101.42L74.4934 97.815ZM81.8394 95.8256C80.7533 94.7994 79.1543 94.9508 78.1524 95.8455L80.5113 98.6184C80.2354 98.8648 79.7188 98.9657 79.3214 98.5902L81.8394 95.8256ZM81.7645 99.8372C83.0208 98.6954 82.9075 96.835 81.8394 95.8256L79.3214 98.5902C78.9648 98.2532 78.8688 97.552 79.3807 97.0867L81.7645 99.8372ZM70.4196 97.8746C69.1519 97.5744 67.6676 98.2219 67.1327 99.6659L70.5409 100.898C70.346 101.424 69.8475 101.585 69.5022 101.503L70.4196 97.8746ZM69.851 99.5897C70.5064 99.751 70.7161 100.425 70.5409 100.898L67.1327 99.6659C66.6043 101.093 67.2922 102.814 68.9036 103.211L69.851 99.5897Z",
    fill: "#8F8B8F"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8368 103.765C68.6602 104.242 68.8993 104.766 69.3773 104.883C71.2932 105.355 73.3232 105.337 75.282 104.824C77.2443 104.309 79.0624 103.318 80.5726 101.945C80.9448 101.607 80.9362 101.027 80.5804 100.691C80.2361 100.366 79.6948 100.391 79.3318 100.715C78.0609 101.85 76.54 102.671 74.9008 103.101C73.2628 103.53 71.5663 103.552 69.9609 103.172C69.4997 103.063 69.0068 103.306 68.8368 103.765Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 100,
    width: 13,
    height: 6
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8368 103.765C68.6602 104.242 68.8993 104.766 69.3773 104.883C71.2932 105.355 73.3232 105.337 75.282 104.824C77.2443 104.309 79.0624 103.318 80.5726 101.945C80.9448 101.607 80.9362 101.027 80.5804 100.691C80.2361 100.366 79.6948 100.391 79.3318 100.715C78.0609 101.85 76.54 102.671 74.9008 103.101C73.2628 103.53 71.5663 103.552 69.9609 103.172C69.4997 103.063 69.0068 103.306 68.8368 103.765Z",
    fill: "#8F8B8F"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3318 100.715L78.1524 99.3285L79.3318 100.715ZM80.5726 101.945L79.3807 100.57L80.5726 101.945ZM68.9036 106.694C71.1092 107.237 73.4417 107.215 75.6895 106.626L74.8746 103.021C73.2047 103.458 71.4773 103.473 69.851 103.073L68.9036 106.694ZM75.6895 106.626C77.9411 106.036 80.0286 104.898 81.7645 103.32L79.3807 100.57C78.0962 101.737 76.5475 102.583 74.8746 103.021L75.6895 106.626ZM78.1524 99.3285C77.1045 100.264 75.8485 100.943 74.4934 101.298L75.3082 104.903C77.2315 104.399 79.0173 103.436 80.5113 102.101L78.1524 99.3285ZM74.4934 101.298C73.1393 101.653 71.7399 101.67 70.4196 101.358L69.5022 104.986C71.3927 105.434 73.3863 105.407 75.3082 104.903L74.4934 101.298ZM81.8394 99.3087C80.7533 98.2824 79.1543 98.4338 78.1524 99.3285L80.5113 102.101C80.2354 102.348 79.7188 102.449 79.3214 102.073L81.8394 99.3087ZM81.7645 103.32C83.0208 102.178 82.9075 100.318 81.8394 99.3087L79.3214 102.073C78.9648 101.736 78.8688 101.035 79.3807 100.57L81.7645 103.32ZM70.4196 101.358C69.1519 101.057 67.6676 101.705 67.1327 103.149L70.5409 104.381C70.346 104.907 69.8475 105.068 69.5022 104.986L70.4196 101.358ZM69.851 103.073C70.5064 103.234 70.7161 103.908 70.5409 104.381L67.1327 103.149C66.6043 104.576 67.2922 106.297 68.9036 106.694L69.851 103.073Z",
    fill: "#8F8B8F"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8368 107.249C68.6602 107.726 68.8993 108.25 69.3773 108.367C71.2932 108.839 73.3232 108.821 75.282 108.308C77.2443 107.793 79.0624 106.802 80.5726 105.429C80.9448 105.091 80.9362 104.511 80.5804 104.175C80.2361 103.85 79.6948 103.875 79.3318 104.199C78.0609 105.334 76.54 106.155 74.9008 106.585C73.2628 107.014 71.5663 107.036 69.9609 106.656C69.4997 106.547 69.0068 106.79 68.8368 107.249Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 103,
    width: 13,
    height: 6
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8368 107.249C68.6602 107.726 68.8993 108.25 69.3773 108.367C71.2932 108.839 73.3232 108.821 75.282 108.308C77.2443 107.793 79.0624 106.802 80.5726 105.429C80.9448 105.091 80.9362 104.511 80.5804 104.175C80.2361 103.85 79.6948 103.875 79.3318 104.199C78.0609 105.334 76.54 106.155 74.9008 106.585C73.2628 107.014 71.5663 107.036 69.9609 106.656C69.4997 106.547 69.0068 106.79 68.8368 107.249Z",
    fill: "#8F8B8F"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3318 104.199L78.1524 102.813L79.3318 104.199ZM80.5726 105.429L79.3807 104.054L80.5726 105.429ZM68.9036 110.178C71.1092 110.721 73.4417 110.699 75.6895 110.11L74.8746 106.505C73.2047 106.942 71.4773 106.957 69.851 106.557L68.9036 110.178ZM75.6895 110.11C77.9411 109.52 80.0286 108.382 81.7645 106.804L79.3807 104.054C78.0962 105.221 76.5475 106.067 74.8746 106.505L75.6895 110.11ZM78.1524 102.813C77.1045 103.748 75.8485 104.427 74.4934 104.782L75.3082 108.387C77.2315 107.883 79.0173 106.92 80.5113 105.585L78.1524 102.813ZM74.4934 104.782C73.1393 105.137 71.7399 105.154 70.4196 104.842L69.5022 108.47C71.3927 108.918 73.3863 108.891 75.3082 108.387L74.4934 104.782ZM81.8394 102.793C80.7533 101.766 79.1543 101.918 78.1524 102.813L80.5113 105.585C80.2354 105.832 79.7188 105.933 79.3214 105.557L81.8394 102.793ZM81.7645 106.804C83.0208 105.662 82.9075 103.802 81.8394 102.793L79.3214 105.557C78.9648 105.22 78.8688 104.519 79.3807 104.054L81.7645 106.804ZM70.4196 104.842C69.1519 104.541 67.6676 105.189 67.1327 106.633L70.5409 107.865C70.346 108.391 69.8475 108.552 69.5022 108.47L70.4196 104.842ZM69.851 106.557C70.5064 106.718 70.7161 107.392 70.5409 107.865L67.1327 106.633C66.6043 108.06 67.2922 109.781 68.9036 110.178L69.851 106.557Z",
    fill: "#8F8B8F"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1475 85.5329C63.1475 85.194 63.4898 84.9622 63.8044 85.0881C64.5658 85.3927 65.4152 85.3927 66.1766 85.0881C66.4913 84.9622 66.8336 85.194 66.8336 85.5329V87.3723C66.8336 87.615 66.6858 87.8333 66.4604 87.9235C65.5168 88.3009 64.4642 88.3009 63.5206 87.9235C63.2953 87.8333 63.1475 87.615 63.1475 87.3723V85.5329Z",
    fill: "white"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M64.069 87.1418V86.1336C64.6754 86.2729 65.3057 86.2729 65.9121 86.1336V87.1418C65.3126 87.3328 64.6684 87.3328 64.069 87.1418Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1475 92.905C63.1475 92.566 63.4898 92.3343 63.8044 92.4602C64.5658 92.7647 65.4152 92.7647 66.1766 92.4602C66.4913 92.3343 66.8336 92.566 66.8336 92.905V94.7444C66.8336 94.9871 66.6858 95.2054 66.4604 95.2956C65.5168 95.673 64.4642 95.673 63.5206 95.2956C63.2953 95.2054 63.1475 94.9871 63.1475 94.7444V92.905Z",
    fill: "white"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M64.069 94.5139V93.5056C64.6754 93.645 65.3057 93.645 65.9121 93.5056V94.5139C65.3126 94.7048 64.6684 94.7048 64.069 94.5139Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1475 100.377C63.1475 99.9697 63.5333 99.6733 63.9265 99.7782C64.6237 99.9641 65.3574 99.9641 66.0545 99.7782C66.4478 99.6733 66.8336 99.9697 66.8336 100.377V100.961C66.8336 101.3 66.6054 101.597 66.2774 101.685C65.4342 101.91 64.5468 101.91 63.7036 101.685C63.3757 101.597 63.1475 101.3 63.1475 100.961V100.377Z",
    fill: "white"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M64.069 100.826V100.754C64.6781 100.867 65.3029 100.867 65.9121 100.754V100.826C65.3058 100.967 64.6753 100.967 64.069 100.826Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1475 106.422C63.1475 106.083 63.4898 105.851 63.8044 105.977C64.5658 106.281 65.4152 106.281 66.1766 105.977C66.4913 105.851 66.8336 106.083 66.8336 106.422V108.261C66.8336 108.504 66.6858 108.722 66.4604 108.812C65.5168 109.19 64.4642 109.19 63.5206 108.812C63.2953 108.722 63.1475 108.504 63.1475 108.261V106.422Z",
    fill: "white"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M64.069 108.031V107.022C64.6754 107.162 65.3057 107.162 65.9121 107.022V108.031C65.3126 108.222 64.6684 108.222 64.069 108.031Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1475 112.565C63.1475 112.226 63.4898 111.995 63.8044 112.12C64.5658 112.425 65.4152 112.425 66.1766 112.12C66.4913 111.995 66.8336 112.226 66.8336 112.565V114.405C66.8336 114.647 66.6858 114.866 66.4604 114.956C65.5168 115.333 64.4642 115.333 63.5206 114.956C63.2953 114.866 63.1475 114.647 63.1475 114.405V112.565Z",
    fill: "white"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M64.069 114.174V113.166C64.6754 113.305 65.3057 113.305 65.9121 113.166V114.174C65.3126 114.365 64.6684 114.365 64.069 114.174Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1475 89.2195C63.1475 88.8806 63.4898 88.6489 63.8044 88.7747C64.5658 89.0793 65.4152 89.0793 66.1766 88.7747C66.4913 88.6489 66.8336 88.8806 66.8336 89.2195V91.0589C66.8336 91.3017 66.6858 91.52 66.4604 91.6101C65.5168 91.9876 64.4642 91.9876 63.5206 91.6101C63.2953 91.52 63.1475 91.3017 63.1475 91.0589V89.2195Z",
    fill: "white"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M64.069 90.8285V89.8202C64.6754 89.9595 65.3057 89.9595 65.9121 89.8202V90.8285C65.3126 91.0194 64.6684 91.0194 64.069 90.8285Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1475 96.5915C63.1475 96.2526 63.4898 96.0208 63.8044 96.1467C64.5658 96.4513 65.4152 96.4513 66.1766 96.1467C66.4913 96.0208 66.8336 96.2526 66.8336 96.5915V98.4309C66.8336 98.6736 66.6858 98.8919 66.4604 98.9821C65.5168 99.3595 64.4642 99.3595 63.5206 98.9821C63.2953 98.8919 63.1475 98.6736 63.1475 98.4309V96.5915Z",
    fill: "white"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M64.069 98.2004V97.1922C64.6754 97.3315 65.3057 97.3315 65.9121 97.1922V98.2004C65.3126 98.3914 64.6684 98.3914 64.069 98.2004Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1475 102.735C63.1475 102.396 63.4898 102.164 63.8044 102.29C64.5658 102.595 65.4152 102.595 66.1766 102.29C66.4913 102.164 66.8336 102.396 66.8336 102.735V104.574C66.8336 104.817 66.6858 105.035 66.4604 105.126C65.5168 105.503 64.4642 105.503 63.5206 105.126C63.2953 105.035 63.1475 104.817 63.1475 104.574V102.735Z",
    fill: "white"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M64.069 104.344V103.336C64.6754 103.475 65.3057 103.475 65.9121 103.336V104.344C65.3126 104.535 64.6684 104.535 64.069 104.344Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1475 110.206C63.1475 109.799 63.5333 109.503 63.9265 109.607C64.6237 109.793 65.3574 109.793 66.0545 109.607C66.4478 109.503 66.8336 109.799 66.8336 110.206V110.79C66.8336 111.129 66.6054 111.426 66.2774 111.514C65.4342 111.739 64.5468 111.739 63.7036 111.514C63.3757 111.426 63.1475 111.129 63.1475 110.79V110.206Z",
    fill: "white"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M64.069 110.655V110.584C64.6781 110.697 65.3029 110.697 65.9121 110.584V110.655C65.3058 110.796 64.6753 110.796 64.069 110.655Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0655 71.9674H71.6139L74.1223 74.2249L71.6139 76.4824H57.0655L54.5571 74.2249L57.0655 71.9674Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6138 78.9905H57.0654V82.0005H71.6138V78.9905Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8578 73.472C50.8547 73.472 50.0221 74.2954 50.2483 75.2726C50.7297 77.3529 52.0384 79.2919 54.0302 80.8241C56.5877 82.7913 60.0691 83.9322 63.7326 84.0036C67.396 84.0749 70.9518 83.0711 73.6422 81.2061C75.8123 79.7017 77.2808 77.7329 77.8676 75.5882C78.095 74.7568 77.4029 74.0193 76.5409 74.0193C75.7595 74.0193 75.0961 74.6472 74.6801 75.3087C73.8207 76.6756 71.9797 78.0052 70.6521 78.9255C68.9069 80.1353 66.109 81.2524 63.7326 81.2061C61.3561 81.1598 58.5707 79.9538 56.9117 78.6776C55.775 77.8032 54.6759 76.5196 54.0966 75.225C53.6869 74.3093 52.8609 73.472 51.8578 73.472Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0882 47.8861C54.391 47.8861 46.5298 55.7473 46.5298 65.4446V67.4385C46.5298 67.4691 46.5305 67.4995 46.5319 67.5297C46.5306 67.5463 46.5299 67.563 46.5299 67.5798C46.5299 70.731 48.8556 73.3988 51.9773 73.8286L61.6434 75.1593C63.2212 75.3765 64.8212 75.3774 66.3991 75.1618L76.1981 73.823C79.3198 73.3965 81.6468 70.73 81.6468 67.5792C81.6468 67.5617 81.6461 67.5444 81.6447 67.5273C81.646 67.4978 81.6467 67.4682 81.6467 67.4385V65.4446C81.6467 55.7473 73.7855 47.8861 64.0882 47.8861ZM64.5734 69.3937H64.8683C65.3654 69.6078 66.095 70.6539 66.095 71.1109C66.095 71.6212 65.706 72.035 65.2262 72.035C64.7463 72.035 64.3573 71.6212 64.3573 71.1109C64.3573 71.0298 64.354 70.9303 64.3503 70.8202V70.8201C64.3332 70.309 64.3084 69.5698 64.5734 69.3937ZM63.3085 69.3937H63.6033C63.8683 69.5698 63.8436 70.309 63.8265 70.8201C63.8228 70.9303 63.8194 71.0298 63.8194 71.1109C63.8194 71.6212 63.4304 72.035 62.9506 72.035C62.4707 72.035 62.0818 71.6212 62.0818 71.1109C62.0818 70.6539 62.8114 69.6078 63.3085 69.3937ZM70.8467 66.5234C72.5083 66.4797 73.8021 64.4238 73.7365 61.9314C73.6709 59.439 72.2707 57.454 70.6091 57.4977C68.9475 57.5415 67.6537 59.5974 67.7193 62.0898C67.7849 64.5821 69.1851 66.5671 70.8467 66.5234ZM54.6765 61.9325C54.6109 64.4248 55.9047 66.4807 57.5663 66.5245C59.2278 66.5682 60.628 64.5832 60.6936 62.0908C60.7592 59.5985 59.4654 57.5425 57.8038 57.4988C56.1422 57.4551 54.7421 59.4401 54.6765 61.9325Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 47,
    width: 36,
    height: 29
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0882 47.8861C54.391 47.8861 46.5298 55.7473 46.5298 65.4446V67.4385C46.5298 67.4691 46.5305 67.4995 46.5319 67.5297C46.5306 67.5463 46.5299 67.563 46.5299 67.5798C46.5299 70.731 48.8556 73.3988 51.9773 73.8286L61.6434 75.1593C63.2212 75.3765 64.8212 75.3774 66.3991 75.1618L76.1981 73.823C79.3198 73.3965 81.6468 70.73 81.6468 67.5792C81.6468 67.5617 81.6461 67.5444 81.6447 67.5273C81.646 67.4978 81.6467 67.4682 81.6467 67.4385V65.4446C81.6467 55.7473 73.7855 47.8861 64.0882 47.8861ZM64.5734 69.3937H64.8683C65.3654 69.6078 66.095 70.6539 66.095 71.1109C66.095 71.6212 65.706 72.035 65.2262 72.035C64.7463 72.035 64.3573 71.6212 64.3573 71.1109C64.3573 71.0298 64.354 70.9303 64.3503 70.8202V70.8201C64.3332 70.309 64.3084 69.5698 64.5734 69.3937ZM63.3085 69.3937H63.6033C63.8683 69.5698 63.8436 70.309 63.8265 70.8201C63.8228 70.9303 63.8194 71.0298 63.8194 71.1109C63.8194 71.6212 63.4304 72.035 62.9506 72.035C62.4707 72.035 62.0818 71.6212 62.0818 71.1109C62.0818 70.6539 62.8114 69.6078 63.3085 69.3937ZM70.8467 66.5234C72.5083 66.4797 73.8021 64.4238 73.7365 61.9314C73.6709 59.439 72.2707 57.454 70.6091 57.4977C68.9475 57.5415 67.6537 59.5974 67.7193 62.0898C67.7849 64.5821 69.1851 66.5671 70.8467 66.5234ZM54.6765 61.9325C54.6109 64.4248 55.9047 66.4807 57.5663 66.5245C59.2278 66.5682 60.628 64.5832 60.6936 62.0908C60.7592 59.5985 59.4654 57.5425 57.8038 57.4988C56.1422 57.4551 54.7421 59.4401 54.6765 61.9325Z",
    fill: "#8F8B8F"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5319 67.5297L48.3693 67.6741L48.3783 67.5597L48.373 67.4451L46.5319 67.5297ZM51.9773 73.8286L51.726 75.6544L51.9773 73.8286ZM61.6434 75.1593L61.3921 76.9852L61.6434 75.1593ZM66.3991 75.1618L66.6486 76.9879L66.3991 75.1618ZM76.1981 73.823L76.4475 75.6491L76.1981 73.823ZM81.6447 67.5273L79.8035 67.4449L79.7983 67.5612L79.8078 67.6773L81.6447 67.5273ZM64.8683 69.3937L65.5972 67.7009L65.2482 67.5506H64.8683V69.3937ZM64.5734 69.3937V67.5506H64.0168L63.5533 67.8587L64.5734 69.3937ZM64.3503 70.8202H62.5073V70.851L62.5083 70.8819L64.3503 70.8202ZM64.3503 70.8201H66.1934V70.7892L66.1923 70.7583L64.3503 70.8201ZM63.6033 69.3937L64.6235 67.8587L64.1599 67.5506H63.6033V69.3937ZM63.3085 69.3937V67.5506H62.9285L62.5796 67.7009L63.3085 69.3937ZM63.8265 70.8201L61.9844 70.7583L61.9834 70.7892V70.8201H63.8265ZM63.8265 70.8201L65.6685 70.8818L65.6695 70.851V70.8201H63.8265ZM73.7365 61.9314L75.5789 61.8829L73.7365 61.9314ZM70.6091 57.4977L70.5606 55.6553L70.6091 57.4977ZM67.7193 62.0898L65.8769 62.1382L67.7193 62.0898ZM57.5663 66.5245L57.5178 68.3669L57.5663 66.5245ZM54.6765 61.9325L56.5189 61.981L54.6765 61.9325ZM60.6936 62.0908L58.8512 62.0423L60.6936 62.0908ZM57.8038 57.4988L57.7553 59.3412L57.8038 57.4988ZM48.3728 65.4446C48.3728 56.7652 55.4089 49.7292 64.0882 49.7292V46.043C53.3731 46.043 44.6867 54.7294 44.6867 65.4446H48.3728ZM48.3728 67.4385V65.4446H44.6867V67.4385H48.3728ZM48.373 67.4451C48.3729 67.4431 48.3728 67.4408 48.3728 67.4385H44.6867C44.6867 67.4973 44.6881 67.5559 44.6908 67.6143L48.373 67.4451ZM44.6945 67.3854C44.6894 67.4499 44.6869 67.5147 44.6869 67.5798H48.373C48.373 67.6112 48.3717 67.6426 48.3693 67.6741L44.6945 67.3854ZM44.6869 67.5798C44.6869 71.6518 47.692 75.0991 51.726 75.6544L52.2287 72.0027C50.0191 71.6985 48.373 69.8103 48.373 67.5798H44.6869ZM51.726 75.6544L61.3921 76.9852L61.8948 73.3335L52.2287 72.0027L51.726 75.6544ZM61.3921 76.9852C63.136 77.2252 64.9045 77.2262 66.6486 76.9879L66.1496 73.3357C64.7379 73.5286 63.3064 73.5278 61.8948 73.3335L61.3921 76.9852ZM66.6486 76.9879L76.4475 75.6491L75.9486 71.9969L66.1496 73.3357L66.6486 76.9879ZM76.4475 75.6491C80.4823 75.0979 83.4899 71.6515 83.4899 67.5792H79.8038C79.8038 69.8085 78.1573 71.6952 75.9486 71.9969L76.4475 75.6491ZM83.4899 67.5792C83.4899 67.5116 83.4871 67.4442 83.4817 67.3773L79.8078 67.6773C79.8051 67.6446 79.8038 67.6119 79.8038 67.5792H83.4899ZM79.8036 67.4385C79.8036 67.4408 79.8036 67.443 79.8035 67.4449L83.4859 67.6096C83.4885 67.5527 83.4897 67.4956 83.4897 67.4385H79.8036ZM79.8036 65.4446V67.4385H83.4897V65.4446H79.8036ZM64.0882 49.7292C72.7676 49.7292 79.8036 56.7652 79.8036 65.4446H83.4897C83.4897 54.7294 74.8034 46.043 64.0882 46.043V49.7292ZM64.8683 67.5506H64.5734V71.2368H64.8683V67.5506ZM64.1393 71.0865C64.0841 71.0627 64.0434 71.0402 64.0178 71.0249C63.9918 71.0093 63.9749 70.9973 63.9672 70.9916C63.9533 70.9813 63.9585 70.9836 63.9808 71.0055C64.0018 71.0261 64.0303 71.0564 64.0637 71.0961C64.0968 71.1355 64.1309 71.1796 64.1638 71.2262C64.1968 71.2728 64.226 71.318 64.2501 71.3589C64.2746 71.4005 64.2903 71.4315 64.2987 71.4498C64.3027 71.4584 64.3037 71.4613 64.3026 71.4586C64.3017 71.456 64.2973 71.4443 64.2914 71.424C64.2857 71.4042 64.2767 71.3694 64.2687 71.3214C64.2609 71.2744 64.252 71.2024 64.252 71.1109H67.9381C67.9381 70.5925 67.7572 70.148 67.6478 69.91C67.5152 69.6217 67.3468 69.3428 67.1723 69.0962C66.9971 68.8488 66.7888 68.5958 66.5586 68.3707C66.3521 68.1686 66.0233 67.8844 65.5972 67.7009L64.1393 71.0865ZM64.252 71.1109C64.252 70.7121 64.5826 70.1919 65.2262 70.1919V73.8781C66.8294 73.8781 67.9381 72.5303 67.9381 71.1109H64.252ZM65.2262 70.1919C65.8697 70.1919 66.2004 70.7121 66.2004 71.1109H62.5143C62.5143 72.5304 63.623 73.8781 65.2262 73.8781V70.1919ZM66.2004 71.1109C66.2004 70.9922 66.1957 70.858 66.1923 70.7584L62.5083 70.8819C62.5123 71.0026 62.5143 71.0675 62.5143 71.1109H66.2004ZM66.1934 70.8202V70.8201H62.5073V70.8202H66.1934ZM66.1934 70.8201H62.5073H66.1934ZM66.1923 70.7583C66.188 70.627 66.1842 70.5115 66.1837 70.3988C66.1833 70.2851 66.1865 70.2036 66.1915 70.1494C66.1976 70.0823 66.201 70.119 66.1694 70.212C66.152 70.2632 66.113 70.3646 66.0341 70.4864C65.9538 70.6103 65.8152 70.7814 65.5936 70.9287L63.5533 67.8587C62.9935 68.2307 62.7691 68.7617 62.6793 69.026C62.5784 69.3231 62.5394 69.6095 62.5207 69.8132C62.4835 70.2198 62.5006 70.6523 62.5083 70.8818L66.1923 70.7583ZM63.6033 67.5506H63.3085V71.2368H63.6033V67.5506ZM62.5832 70.9287C62.3615 70.7814 62.2229 70.6103 62.1427 70.4864C62.0638 70.3646 62.0247 70.2632 62.0073 70.212C61.9758 70.119 61.9792 70.0823 61.9853 70.1494C61.9903 70.2036 61.9935 70.2851 61.993 70.3988C61.9926 70.5114 61.9888 70.627 61.9844 70.7583L65.6685 70.8818C65.6762 70.6523 65.6933 70.2198 65.6561 69.8132C65.6374 69.6095 65.5984 69.3231 65.4975 69.026C65.4077 68.7617 65.1833 68.2307 64.6235 67.8587L62.5832 70.9287ZM61.9834 70.8201H65.6695H61.9834ZM61.9844 70.7584C61.9811 70.858 61.9764 70.9922 61.9764 71.1109H65.6625C65.6625 71.0674 65.6644 71.0025 65.6685 70.8818L61.9844 70.7584ZM61.9764 71.1109C61.9764 70.7121 62.3071 70.1919 62.9506 70.1919V73.8781C64.5538 73.8781 65.6625 72.5304 65.6625 71.1109H61.9764ZM62.9506 70.1919C63.5941 70.1919 63.9248 70.7121 63.9248 71.1109H60.2387C60.2387 72.5304 61.3474 73.8781 62.9506 73.8781V70.1919ZM63.9248 71.1109C63.9248 71.2024 63.9159 71.2744 63.9081 71.3214C63.9001 71.3694 63.891 71.4042 63.8854 71.424C63.8795 71.4443 63.8751 71.4561 63.8742 71.4586C63.8731 71.4613 63.8741 71.4584 63.8781 71.4498C63.8865 71.4315 63.9021 71.4005 63.9267 71.3589C63.9508 71.318 63.98 71.2728 64.0129 71.2262C64.0459 71.1796 64.08 71.1355 64.1131 71.0961C64.1465 71.0564 64.1749 71.0261 64.196 71.0055C64.2183 70.9836 64.2235 70.9813 64.2096 70.9916C64.2019 70.9973 64.185 71.0093 64.159 71.0249C64.1334 71.0402 64.0927 71.0627 64.0375 71.0865L62.5796 67.7009C62.1535 67.8844 61.8247 68.1686 61.6182 68.3707C61.388 68.5958 61.1797 68.8488 61.0045 69.0962C60.8299 69.3428 60.6615 69.6217 60.529 69.91C60.4196 70.148 60.2387 70.5925 60.2387 71.1109H63.9248ZM71.894 61.9799C71.9186 62.9131 71.6831 63.6813 71.3794 64.164C71.0674 64.6598 70.8213 64.6804 70.7982 64.681L70.8952 68.3658C72.5336 68.3227 73.7653 67.2934 74.4991 66.1273C75.2413 64.948 75.6199 63.4421 75.5789 61.8829L71.894 61.9799ZM70.6576 59.3402C70.6807 59.3395 70.9275 59.3471 71.2652 59.8259C71.5939 60.2919 71.8695 61.0467 71.894 61.9799L75.5789 61.8829C75.5378 60.3237 75.0805 58.8398 74.2774 57.7012C73.4832 56.5752 72.1991 55.6122 70.5606 55.6553L70.6576 59.3402ZM69.5618 62.0413C69.5372 61.1081 69.7727 60.3399 70.0764 59.8571C70.3884 59.3613 70.6345 59.3408 70.6576 59.3402L70.5606 55.6553C68.9222 55.6984 67.6905 56.7277 66.9567 57.8939C66.2145 59.0731 65.8359 60.5791 65.8769 62.1382L69.5618 62.0413ZM70.7982 64.681C70.7751 64.6816 70.5283 64.674 70.1906 64.1953C69.8619 63.7292 69.5863 62.9744 69.5618 62.0413L65.8769 62.1382C65.918 63.6974 66.3753 65.1814 67.1784 66.32C67.9726 67.4459 69.2567 68.4089 70.8952 68.3658L70.7982 64.681ZM57.6147 64.6821C57.5916 64.6814 57.3456 64.6609 57.0336 64.1651C56.7298 63.6823 56.4943 62.9141 56.5189 61.981L52.8341 61.884C52.793 63.4432 53.1717 64.9491 53.9138 66.1283C54.6477 67.2945 55.8793 68.3238 57.5178 68.3669L57.6147 64.6821ZM58.8512 62.0423C58.8266 62.9755 58.5511 63.7303 58.2223 64.1964C57.8847 64.6751 57.6378 64.6827 57.6147 64.6821L57.5178 68.3669C59.1562 68.41 60.4403 67.447 61.2345 66.321C62.0376 65.1824 62.495 63.6985 62.536 62.1393L58.8512 62.0423ZM57.7553 59.3412C57.7784 59.3418 58.0245 59.3624 58.3365 59.8582C58.6403 60.3409 58.8757 61.1092 58.8512 62.0423L62.536 62.1393C62.577 60.5801 62.1984 59.0742 61.4563 57.8949C60.7224 56.7288 59.4908 55.6995 57.8523 55.6564L57.7553 59.3412ZM56.5189 61.981C56.5435 61.0478 56.819 60.293 57.1477 59.8269C57.4854 59.3482 57.7322 59.3406 57.7553 59.3412L57.8523 55.6564C56.2138 55.6133 54.9298 56.5763 54.1356 57.7023C53.3324 58.8409 52.8751 60.3248 52.8341 61.884L56.5189 61.981Z",
    fill: "#8F8B8F"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1146 127.786C72.1146 124.654 68.9963 122.885 64.8403 122.885C60.6844 122.885 57.0645 124.654 57.0645 127.786C57.0645 130.917 57.4825 134.34 64.5895 128.487C70.8604 134.34 72.1146 130.917 72.1146 127.786Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6398 119.613C79.6398 122.845 72.9016 125.466 64.5897 125.466C56.2777 125.466 49.5396 122.845 49.5396 119.613C49.5396 116.381 57.4827 112.499 64.5897 117.517C72.9508 112.499 79.6398 116.381 79.6398 119.613ZM60.5661 122.212C60.1541 123.535 56.6017 122.729 55.2791 122.317C53.9565 121.905 53.2183 120.498 53.6303 119.176C54.0423 117.853 55.4486 117.115 56.7712 117.527C58.0938 117.939 60.9782 120.89 60.5661 122.212ZM74.2161 122.317C72.8935 122.729 69.3411 123.535 68.9291 122.212C68.5171 120.89 71.4014 117.939 72.724 117.527C74.0467 117.115 75.4529 117.853 75.8649 119.176C76.277 120.498 75.5388 121.905 74.2161 122.317Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5897 117.517L64.0581 118.27L64.5488 118.616L65.0639 118.307L64.5897 117.517ZM55.2791 122.317L55.005 123.197L55.2791 122.317ZM53.6303 119.176L54.5101 119.45L53.6303 119.176ZM56.7712 117.527L56.4971 118.407L56.7712 117.527ZM68.9291 122.212L68.0493 122.486L68.9291 122.212ZM74.2161 122.317L74.4902 123.197L74.2161 122.317ZM75.8649 119.176L76.7448 118.902H76.7447L75.8649 119.176ZM64.5897 126.387C68.8302 126.387 72.7111 125.721 75.5657 124.61C76.9901 124.057 78.2056 123.374 79.0808 122.57C79.9567 121.764 80.5613 120.766 80.5613 119.613H78.7182C78.7182 120.076 78.4805 120.618 77.8333 121.213C77.1854 121.809 76.1969 122.388 74.8977 122.893C72.3052 123.901 68.6611 124.544 64.5897 124.544V126.387ZM48.618 119.613C48.618 120.766 49.2226 121.764 50.0985 122.57C50.9737 123.374 52.1893 124.057 53.6136 124.61C56.4682 125.721 60.3491 126.387 64.5897 126.387V124.544C60.5182 124.544 56.8741 123.901 54.2816 122.893C52.9825 122.388 51.994 121.809 51.346 121.213C50.6988 120.618 50.4611 120.076 50.4611 119.613H48.618ZM65.1212 116.764C61.33 114.087 57.2846 113.769 54.1676 114.579C52.6157 114.983 51.2677 115.673 50.2889 116.519C49.3303 117.348 48.618 118.429 48.618 119.613H50.4611C50.4611 119.181 50.7417 118.564 51.4945 117.913C52.2271 117.28 53.3091 116.707 54.6314 116.363C57.2626 115.679 60.7423 115.928 64.0581 118.27L65.1212 116.764ZM80.5613 119.613C80.5613 118.485 79.9842 117.413 79.1079 116.557C78.2234 115.693 76.9819 114.992 75.4945 114.582C72.5041 113.76 68.4837 114.105 64.1154 116.727L65.0639 118.307C69.0568 115.911 72.5615 115.687 75.0058 116.36C76.2358 116.698 77.189 117.259 77.8201 117.875C78.4593 118.5 78.7182 119.125 78.7182 119.613H80.5613ZM55.005 123.197C55.7047 123.415 56.9946 123.739 58.1912 123.834C58.7821 123.881 59.4228 123.878 59.9779 123.738C60.5236 123.6 61.2036 123.264 61.446 122.486L59.6863 121.938C59.7227 121.821 59.8041 121.881 59.5265 121.951C59.2584 122.019 58.8511 122.037 58.337 121.996C57.3238 121.916 56.1761 121.631 55.5532 121.437L55.005 123.197ZM52.7505 118.902C52.1871 120.71 53.1965 122.633 55.005 123.197L55.5532 121.437C54.7165 121.176 54.2495 120.287 54.5101 119.45L52.7505 118.902ZM57.0453 116.647C55.2367 116.084 53.3139 117.093 52.7505 118.902L54.5101 119.45C54.7708 118.613 55.6604 118.146 56.4971 118.407L57.0453 116.647ZM61.446 122.486C61.6596 121.801 61.4162 121.089 61.1582 120.57C60.8783 120.007 60.4619 119.435 60.0128 118.921C59.5601 118.404 59.0477 117.916 58.5511 117.524C58.0744 117.147 57.5395 116.801 57.0453 116.647L56.4971 118.407C56.6642 118.459 56.9858 118.636 57.4091 118.97C57.8124 119.289 58.2433 119.698 58.6256 120.135C59.0114 120.576 59.3215 121.015 59.5078 121.39C59.7161 121.809 59.6787 121.962 59.6863 121.938L61.446 122.486ZM68.0493 122.486C68.2916 123.264 68.9716 123.6 69.5173 123.738C70.0724 123.878 70.7132 123.881 71.3041 123.834C72.5007 123.739 73.7905 123.415 74.4902 123.197L73.942 121.437C73.3191 121.631 72.1715 121.916 71.1582 121.996C70.6442 122.037 70.2369 122.019 69.9687 121.951C69.6911 121.881 69.7726 121.821 69.8089 121.938L68.0493 122.486ZM72.45 116.647C71.9558 116.801 71.4208 117.147 70.9441 117.524C70.4475 117.916 69.9351 118.404 69.4825 118.921C69.0333 119.435 68.617 120.007 68.337 120.57C68.0791 121.089 67.8357 121.801 68.0493 122.486L69.8089 121.938C69.8165 121.962 69.7791 121.809 69.9875 121.39C70.1738 121.015 70.4839 120.576 70.8697 120.135C71.2519 119.698 71.6829 119.289 72.0862 118.97C72.5094 118.636 72.831 118.459 72.9981 118.407L72.45 116.647ZM76.7447 118.902C76.1813 117.093 74.2585 116.084 72.45 116.647L72.9981 118.407C73.8348 118.146 74.7244 118.613 74.9851 119.45L76.7447 118.902ZM74.4902 123.197C76.2988 122.633 77.3081 120.71 76.7448 118.902L74.9851 119.45C75.2458 120.287 74.7788 121.176 73.942 121.437L74.4902 123.197Z",
    fill: "#8F8B8F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M79.722 127.652C79.722 128.677 78.7007 129.74 77.1318 129.74C75.5629 129.74 74.5416 128.677 74.5416 127.652C74.5416 126.627 75.5629 125.563 77.1318 125.563C78.7007 125.563 79.722 126.627 79.722 127.652Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M54.638 128.154C54.638 129.179 53.6167 130.243 52.0478 130.243C50.4789 130.243 49.4577 129.179 49.4577 128.154C49.4577 127.129 50.4789 126.066 52.0478 126.066C53.6167 126.066 54.638 127.129 54.638 128.154Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.568 103.256H144.653V164.691H149.568V103.256Z",
    fill: "white"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M148.646 104.178H145.574V163.77H148.646V104.178Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.558 76.7801C119.177 75.9654 119.772 75.0315 120.671 75.0315H157.338C158.3 75.0315 159.173 75.5927 159.573 76.4677L171.416 102.389C171.788 103.203 171.193 104.128 170.299 104.128H133.893C132.938 104.128 132.07 103.576 131.666 102.711L119.558 76.7801Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.301 78.0409H156.71L167.445 101.118H135.239L124.301 78.0409Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.301 78.0409H156.71L167.445 101.118H135.239L124.301 78.0409Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4 95.4582C136.242 95.1195 136.429 94.8612 136.818 94.8813C137.207 94.9013 137.651 95.1922 137.809 95.5309L137.853 95.6237C138.035 96.0136 137.819 96.311 137.371 96.2879L137.241 96.2812C136.983 96.2678 136.688 96.0747 136.583 95.8498L136.4 95.4582Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34 91.7152L135.34 91.7152C134.882 91.6916 134.662 91.9953 134.849 92.3935L134.933 92.575C135.12 92.9732 135.641 93.3152 136.099 93.3388L136.099 93.3388C136.557 93.3624 136.777 93.0587 136.59 92.6605L136.506 92.4789C136.319 92.0807 135.798 91.7388 135.34 91.7152Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.62514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.909 88.6507L133.909 88.6507C133.451 88.6271 133.231 88.9308 133.418 89.329L133.504 89.5146C133.691 89.9128 134.212 90.2547 134.67 90.2783L134.67 90.2783C135.127 90.3019 135.347 89.9982 135.161 89.6L135.075 89.4144C134.888 89.0162 134.367 88.6743 133.909 88.6507Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.62514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.481 85.5925L132.481 85.5925C132.023 85.5689 131.803 85.8726 131.99 86.2708L132.074 86.4523C132.261 86.8505 132.782 87.1925 133.24 87.2161L133.24 87.2161C133.698 87.2397 133.918 86.936 133.731 86.5378L133.647 86.3562C133.46 85.958 132.939 85.6161 132.481 85.5925Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.62514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.049 82.5238L131.049 82.5238C130.591 82.5002 130.371 82.8039 130.558 83.2021L130.642 83.3836C130.829 83.7818 131.35 84.1238 131.808 84.1474L131.808 84.1474C132.266 84.171 132.486 83.8673 132.299 83.4691L132.215 83.2875C132.028 82.8893 131.507 82.5474 131.049 82.5238Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.62514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.537 94.9373L140.537 94.9373C140.079 94.9137 139.859 95.2174 140.046 95.6156L140.132 95.8012C140.319 96.1994 140.84 96.5413 141.298 96.5649L141.298 96.5649C141.755 96.5885 141.975 96.2848 141.789 95.8866L141.703 95.701C141.516 95.3028 140.995 94.9609 140.537 94.9373Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.62514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.109 91.8802L139.109 91.8802C138.651 91.8566 138.431 92.1603 138.618 92.5585L138.702 92.74C138.889 93.1382 139.41 93.4802 139.868 93.5038L139.868 93.5038C140.326 93.5274 140.546 93.2237 140.359 92.8255L140.275 92.6439C140.088 92.2457 139.567 91.9038 139.109 91.8802Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.62514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.679 88.8136L137.679 88.8136C137.221 88.79 137.001 89.0937 137.188 89.4919L137.274 89.6775C137.461 90.0757 137.982 90.4176 138.44 90.4412L138.44 90.4412C138.897 90.4648 139.117 90.1611 138.931 89.7629L138.845 89.5773C138.658 89.1791 138.137 88.8372 137.679 88.8136Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.62514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.25 85.7564L136.25 85.7564C135.792 85.7328 135.572 86.0365 135.759 86.4347L135.843 86.6162C136.03 87.0144 136.551 87.3564 137.009 87.38L137.009 87.38C137.467 87.4036 137.687 87.0999 137.5 86.7017L137.416 86.5201C137.229 86.1219 136.708 85.78 136.25 85.7564Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.62514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.471 83.4167C134.286 83.0201 134.488 82.7105 134.932 82.7106H135.057C135.349 82.7106 135.698 82.9351 135.81 83.1954L135.996 83.6254C136.144 83.9681 135.948 84.2241 135.553 84.2037C135.149 84.1829 134.689 83.8811 134.524 83.5297L134.471 83.4167Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.411 81.7468H156.472",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.93 85.1526H162.667",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.433 88.5628H164.17",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.935 91.9742H165.672",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.936 95.3825H166.673",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.908 164.691C129.908 162.655 131.559 161.005 133.594 161.005H160.626C162.662 161.005 164.312 162.655 164.312 164.691H129.908Z",
    fill: "white"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M129.908 164.691C129.908 162.655 131.559 161.005 133.594 161.005H160.626C162.662 161.005 164.312 162.655 164.312 164.691H129.908Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_i_1_2)"
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.085 78.2151L218.085 78.2151C212.531 78.205 208.02 82.6994 208.01 88.2537L207.968 110.91C207.958 116.464 212.453 120.975 218.007 120.985L218.007 120.985C223.561 120.995 228.072 116.501 228.082 110.947L228.124 88.2903C228.134 82.7361 223.639 78.2252 218.085 78.2151Z",
    fill: "white"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M227.202 88.2887C227.211 83.2433 223.129 79.1458 218.083 79.1366C213.038 79.1275 208.941 83.2101 208.931 88.2554L208.89 110.912C208.881 115.957 212.963 120.054 218.009 120.064C223.054 120.073 227.152 115.99 227.161 110.945L227.202 88.2887Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.038 112.52C202.49 114.251 204.268 123.974 201.009 134.236C200.434 136.048 199.74 137.756 198.957 139.33C199.384 141.6 199.587 144.076 199.52 146.661C199.239 157.425 194.376 166.03 188.658 165.881C182.939 165.732 178.53 156.885 178.811 146.122C178.874 143.681 179.174 141.35 179.665 139.208C179.496 135.829 180.003 131.938 181.265 127.965C184.524 117.703 191.585 110.788 197.038 112.52Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 112,
    width: 25,
    height: 54
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.038 112.52C202.49 114.251 204.268 123.974 201.009 134.236C200.434 136.048 199.74 137.756 198.957 139.33C199.384 141.6 199.587 144.076 199.52 146.661C199.239 157.425 194.376 166.03 188.658 165.881C182.939 165.732 178.53 156.885 178.811 146.122C178.874 143.681 179.174 141.35 179.665 139.208C179.496 135.829 180.003 131.938 181.265 127.965C184.524 117.703 191.585 110.788 197.038 112.52Z",
    fill: "#8F8B8F"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.009 134.236L202.766 134.794L201.009 134.236ZM197.038 112.52L197.596 110.763L197.038 112.52ZM198.957 139.33L197.306 138.509L197.031 139.063L197.145 139.671L198.957 139.33ZM199.52 146.661L201.362 146.709L199.52 146.661ZM188.658 165.881L188.61 167.723L188.658 165.881ZM178.811 146.122L180.653 146.17L178.811 146.122ZM179.665 139.208L181.462 139.62L181.519 139.371L181.506 139.116L179.665 139.208ZM181.265 127.965L183.021 128.523L181.265 127.965ZM202.766 134.794C204.468 129.434 204.886 124.129 204.103 119.847C203.337 115.656 201.29 111.936 197.596 110.763L196.48 114.276C198.238 114.835 199.806 116.842 200.477 120.51C201.131 124.089 200.809 128.776 199.252 133.678L202.766 134.794ZM200.607 140.15C201.433 138.49 202.162 136.694 202.766 134.794L199.252 133.678C198.705 135.402 198.046 137.021 197.306 138.509L200.607 140.15ZM201.362 146.709C201.433 143.998 201.22 141.392 200.768 138.989L197.145 139.671C197.547 141.808 197.741 144.153 197.677 146.613L201.362 146.709ZM188.61 167.723C192.484 167.824 195.636 164.979 197.733 161.27C199.874 157.481 201.216 152.331 201.362 146.709L197.677 146.613C197.543 151.755 196.313 156.289 194.524 159.456C192.689 162.703 190.55 164.086 188.706 164.038L188.61 167.723ZM176.968 146.074C176.822 151.696 177.893 156.908 179.835 160.804C181.735 164.617 184.735 167.622 188.61 167.723L188.706 164.038C186.862 163.99 184.797 162.497 183.134 159.16C181.511 155.904 180.519 151.312 180.653 146.17L176.968 146.074ZM177.869 138.795C177.349 141.061 177.035 143.514 176.968 146.074L180.653 146.17C180.713 143.847 180.998 141.639 181.462 139.62L177.869 138.795ZM179.508 127.408C178.187 131.566 177.643 135.678 177.824 139.3L181.506 139.116C181.349 135.98 181.819 132.309 183.021 128.523L179.508 127.408ZM197.596 110.763C193.901 109.59 190.083 111.447 187.039 114.428C183.929 117.473 181.21 122.048 179.508 127.408L183.021 128.523C184.578 123.621 187.019 119.607 189.618 117.062C192.283 114.453 194.722 113.718 196.48 114.276L197.596 110.763Z",
    fill: "#8F8B8F"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.299 93.8971C201.944 98.7449 190.792 101.877 177.392 100.894C163.991 99.9102 153.417 95.1828 153.773 90.3349C154.128 85.4871 165.28 82.3545 178.68 83.3382C192.081 84.3218 202.655 89.0492 202.299 93.8971Z",
    fill: "white"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M177.459 99.9748C184.081 100.461 190.108 99.9255 194.488 98.6951C196.682 98.0788 198.413 97.302 199.596 96.4316C200.782 95.5586 201.319 94.671 201.38 93.8296C201.442 92.9882 201.041 92.0319 199.995 90.995C198.952 89.9611 197.353 88.9399 195.272 88.0098C191.119 86.1531 185.235 84.7434 178.613 84.2572C171.991 83.7711 165.964 84.3066 161.584 85.5369C159.39 86.1532 157.659 86.9301 156.476 87.8005C155.29 88.6735 154.753 89.561 154.692 90.4024C154.63 91.2438 155.031 92.2001 156.077 93.2371C157.121 94.2709 158.719 95.2921 160.8 96.2222C164.953 98.079 170.837 99.4887 177.459 99.9748Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.652 133.053C192.996 131.56 183.896 121.64 180.785 108.11C177.027 91.7671 183.432 76.3451 195.091 73.6644C200.895 72.33 206.906 74.4042 211.944 78.8401C215.9 78.1279 223.509 82.2938 230.508 89.3177C238.752 97.5918 243.027 106.699 240.056 109.658C237.578 112.127 230.841 109.538 223.889 103.809C224.58 110.91 223.375 117.571 220.703 122.755C221.806 125.104 222.694 127.795 223.265 130.707C223.672 132.781 223.889 134.812 223.931 136.746C224.899 139.658 225.478 143.071 225.525 146.726C225.665 157.492 221.141 166.28 215.421 166.354C209.701 166.428 204.95 157.76 204.811 146.994C204.788 145.197 204.894 143.454 205.115 141.798C204.189 139.658 203.44 137.263 202.937 134.697C202.828 134.145 202.734 133.597 202.652 133.053Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 73,
    width: 62,
    height: 94
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.652 133.053C192.996 131.56 183.896 121.64 180.785 108.11C177.027 91.7671 183.432 76.3451 195.091 73.6644C200.895 72.33 206.906 74.4042 211.944 78.8401C215.9 78.1279 223.509 82.2938 230.508 89.3177C238.752 97.5918 243.027 106.699 240.056 109.658C237.578 112.127 230.841 109.538 223.889 103.809C224.58 110.91 223.375 117.571 220.703 122.755C221.806 125.104 222.694 127.795 223.265 130.707C223.672 132.781 223.889 134.812 223.931 136.746C224.899 139.658 225.478 143.071 225.525 146.726C225.665 157.492 221.141 166.28 215.421 166.354C209.701 166.428 204.95 157.76 204.811 146.994C204.788 145.197 204.894 143.454 205.115 141.798C204.189 139.658 203.44 137.263 202.937 134.697C202.828 134.145 202.734 133.597 202.652 133.053Z",
    fill: "#8F8B8F"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.785 108.11L182.581 107.697L180.785 108.11ZM202.652 133.053L204.475 132.78L204.274 131.439L202.934 131.232L202.652 133.053ZM195.091 73.6644L195.504 75.4606L195.091 73.6644ZM211.944 78.8401L210.726 80.2233L211.394 80.8117L212.27 80.654L211.944 78.8401ZM230.508 89.3177L231.813 88.0169L230.508 89.3177ZM240.056 109.658L241.357 110.964L240.056 109.658ZM223.889 103.809L225.061 102.387L221.623 99.553L222.055 103.987L223.889 103.809ZM220.703 122.755L219.065 121.91L218.65 122.717L219.035 123.538L220.703 122.755ZM223.265 130.707L221.456 131.062L223.265 130.707ZM223.931 136.746L222.089 136.787L222.095 137.064L222.182 137.328L223.931 136.746ZM225.525 146.726L227.368 146.702L225.525 146.726ZM215.421 166.354L215.445 168.197L215.421 166.354ZM204.811 146.994L202.968 147.018L204.811 146.994ZM205.115 141.798L206.942 142.041L207.009 141.535L206.806 141.066L205.115 141.798ZM202.937 134.697L204.745 134.342L202.937 134.697ZM178.989 108.523C182.201 122.493 191.709 133.226 202.37 134.875L202.934 131.232C194.283 129.894 185.591 120.787 182.581 107.697L178.989 108.523ZM194.678 71.8682C188.117 73.3768 183.205 78.4343 180.455 85.057C177.702 91.6838 177.034 100.021 178.989 108.523L182.581 107.697C180.778 99.8564 181.433 92.311 183.859 86.4708C186.286 80.6265 190.406 76.6327 195.504 75.4606L194.678 71.8682ZM213.162 77.4568C207.808 72.7427 201.21 70.3664 194.678 71.8682L195.504 75.4606C200.579 74.2937 206.004 76.0657 210.726 80.2233L213.162 77.4568ZM231.813 88.0169C228.216 84.4061 224.43 81.497 220.985 79.5695C219.263 78.6058 217.591 77.8681 216.043 77.419C214.515 76.9756 212.99 76.779 211.617 77.0261L212.27 80.654C212.876 80.545 213.786 80.6021 215.016 80.9591C216.226 81.3103 217.636 81.9195 219.185 82.7863C222.283 84.5196 225.801 87.2055 229.202 90.6186L231.813 88.0169ZM241.357 110.964C242.63 109.695 242.949 107.938 242.814 106.248C242.678 104.548 242.072 102.65 241.156 100.698C239.316 96.7788 236.045 92.2637 231.813 88.0169L229.202 90.6186C233.215 94.6459 236.203 98.8211 237.819 102.264C238.631 103.993 239.052 105.443 239.14 106.542C239.228 107.65 238.967 108.141 238.755 108.353L241.357 110.964ZM222.717 105.231C226.293 108.179 229.894 110.389 233.013 111.537C234.569 112.111 236.095 112.454 237.488 112.434C238.891 112.415 240.298 112.019 241.357 110.964L238.755 108.353C238.576 108.532 238.211 108.738 237.437 108.749C236.652 108.759 235.594 108.56 234.287 108.079C231.68 107.118 228.437 105.169 225.061 102.387L222.717 105.231ZM222.342 123.599C225.198 118.057 226.444 111.033 225.724 103.63L222.055 103.987C222.717 110.788 221.552 117.084 219.065 121.91L222.342 123.599ZM225.074 130.352C224.475 127.3 223.542 124.464 222.372 121.971L219.035 123.538C220.071 125.744 220.913 128.291 221.456 131.062L225.074 130.352ZM225.774 136.706C225.729 134.664 225.501 132.527 225.074 130.352L221.456 131.062C221.844 133.035 222.049 134.961 222.089 136.787L225.774 136.706ZM227.368 146.702C227.319 142.873 226.713 139.27 225.68 136.165L222.182 137.328C223.086 140.045 223.637 143.269 223.682 146.75L227.368 146.702ZM215.445 168.197C219.32 168.146 222.359 165.181 224.309 161.393C226.301 157.523 227.441 152.325 227.368 146.702L223.682 146.75C223.749 151.892 222.697 156.471 221.032 159.706C219.325 163.021 217.242 164.487 215.397 164.511L215.445 168.197ZM202.968 147.018C203.041 152.641 204.315 157.808 206.407 161.625C208.455 165.361 211.569 168.247 215.445 168.197L215.397 164.511C213.553 164.535 211.432 163.124 209.639 159.853C207.891 156.663 206.72 152.113 206.654 146.97L202.968 147.018ZM203.288 141.555C203.055 143.301 202.944 145.133 202.968 147.018L206.654 146.97C206.632 145.261 206.733 143.607 206.942 142.041L203.288 141.555ZM201.128 135.052C201.656 137.742 202.443 140.264 203.423 142.53L206.806 141.066C205.935 139.052 205.224 136.783 204.745 134.342L201.128 135.052ZM200.829 133.327C200.915 133.898 201.015 134.473 201.128 135.052L204.745 134.342C204.642 133.818 204.552 133.297 204.475 132.78L200.829 133.327Z",
    fill: "#8F8B8F"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_ii_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.289 84.0564C204.256 92.9211 190.557 93.5951 181.692 85.5618C172.828 77.5285 172.154 63.83 180.187 54.9654C188.22 46.1007 201.919 45.4267 210.784 53.46C219.648 61.4933 220.322 75.1917 212.289 84.0564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.606 83.4376C203.915 91.9251 190.799 92.5704 182.311 84.8789C173.824 77.1874 173.179 64.0717 180.87 55.5842C188.561 47.0967 201.677 46.4514 210.165 54.1429C218.652 61.8344 219.297 74.9501 211.606 83.4376Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.776 73.0073C176.379 80.7473 183.086 85.9021 189.757 84.5207C196.428 83.1394 200.537 75.7452 198.935 68.0051C197.332 60.2651 191.84 60.9813 185.169 62.3626C178.498 63.7439 173.173 65.2673 174.776 73.0073Z",
    fill: "white"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M175.678 72.8204C177.205 80.1926 183.519 84.8714 189.57 83.6184C195.622 82.3653 199.559 75.5641 198.032 68.192C197.652 66.357 197.059 65.1072 196.342 64.2586C195.635 63.4222 194.765 62.9224 193.724 62.6562C191.56 62.1025 188.737 62.5651 185.356 63.265C181.976 63.965 179.201 64.6616 177.434 66.0291C176.585 66.6866 175.984 67.4911 175.668 68.5392C175.347 69.6027 175.299 70.9854 175.678 72.8204Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M179.972 71.5832C180.182 72.62 180.139 73.5594 179.943 74.2259C179.733 74.9371 179.439 75.1021 179.327 75.1248C179.215 75.1474 178.88 75.11 178.41 74.5367C177.969 73.9995 177.564 73.1511 177.353 72.1143C177.143 71.0775 177.186 70.1382 177.383 69.4717C177.592 68.7605 177.887 68.5955 177.998 68.5728C178.11 68.5502 178.445 68.5876 178.915 69.1609C179.356 69.6981 179.762 70.5464 179.972 71.5832Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M190.532 68.6234C190.74 69.6518 190.641 70.5987 190.36 71.2875C190.076 71.9835 189.659 72.3162 189.267 72.3957C188.875 72.4752 188.361 72.3313 187.828 71.8011C187.3 71.2764 186.84 70.4429 186.632 69.4144C186.423 68.386 186.522 67.439 186.803 66.7503C187.088 66.0543 187.505 65.7216 187.897 65.6421C188.289 65.5626 188.803 65.7065 189.336 66.2367C189.863 66.7614 190.323 67.5949 190.532 68.6234Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.84306
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M155.84 39.9783H155.84C156.519 39.9783 157.069 40.5286 157.069 41.2075V52.68C157.069 53.3589 156.519 53.9092 155.84 53.9092H155.84C155.161 53.9092 154.611 53.3589 154.611 52.68V41.2075C154.611 40.5286 155.161 39.9783 155.84 39.9783Z",
    fill: "#8F8B8F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M162.806 46.9446V46.9446C162.806 47.6235 162.256 48.1738 161.577 48.1738H150.104C149.425 48.1738 148.875 47.6235 148.875 46.9446V46.9446C148.875 46.2657 149.425 45.7154 150.104 45.7154H161.577C162.256 45.7154 162.806 46.2657 162.806 46.9446Z",
    fill: "#8F8B8F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M110.866 142.064H133.811C134.49 142.064 135.04 142.614 135.04 143.293V143.293C135.04 143.972 134.49 144.522 133.811 144.522H110.866C110.187 144.522 109.637 143.972 109.637 143.293C109.637 142.614 110.187 142.064 110.866 142.064Z",
    fill: "#8F8B8F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9349 149.101H119.88C120.559 149.101 121.109 149.651 121.109 150.33V150.33C121.109 151.009 120.559 151.559 119.88 151.559H96.9349C96.256 151.559 95.7057 151.009 95.7057 150.33C95.7057 149.651 96.256 149.101 96.9349 149.101Z",
    fill: "#8F8B8F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M179.603 20.6116H156.658C155.979 20.6116 155.429 20.0613 155.429 19.3824V19.3824C155.429 18.7035 155.979 18.1532 156.658 18.1532H179.603C180.282 18.1532 180.832 18.7035 180.832 19.3824C180.832 20.0613 180.282 20.6116 179.603 20.6116Z",
    fill: "#8F8B8F"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M195.173 11.5977H166.492C165.813 11.5977 165.263 11.0474 165.263 10.3685V10.3685C165.263 9.68964 165.813 9.13931 166.492 9.13931H195.173C195.852 9.13931 196.403 9.68964 196.403 10.3685C196.403 11.0474 195.852 11.5977 195.173 11.5977Z",
    fill: "#8F8B8F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M159.938 11.5977H150.104C149.425 11.5977 148.875 11.0474 148.875 10.3685V10.3685C148.875 9.68964 149.425 9.13931 150.104 9.13931H159.938C160.617 9.13931 161.167 9.68964 161.167 10.3685V10.3685C161.167 11.0474 160.617 11.5977 159.938 11.5977Z",
    fill: "#8F8B8F"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.056 49.4682C227.435 49.4682 224.5 46.5331 224.5 42.9125C224.5 39.2919 227.435 36.3568 231.056 36.3568C234.677 36.3568 237.612 39.2919 237.612 42.9125C237.612 46.5331 234.677 49.4682 231.056 49.4682Z",
    fill: "white"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M231.056 48.6056C227.912 48.6056 225.363 46.0567 225.363 42.9125C225.363 39.7683 227.912 37.2194 231.056 37.2194C234.2 37.2194 236.749 39.7683 236.749 42.9125C236.749 46.0567 234.2 48.6056 231.056 48.6056Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.72518
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_i_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3159 154.112C15.6953 154.112 12.7602 151.177 12.7602 147.556C12.7602 143.935 15.6953 141 19.3159 141C22.9365 141 25.8716 143.935 25.8716 147.556C25.8716 151.177 22.9365 154.112 19.3159 154.112Z",
    fill: "white"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3159 153.249C16.1717 153.249 13.6228 150.7 13.6228 147.556C13.6228 144.412 16.1717 141.863 19.3159 141.863C22.4601 141.863 25.009 144.412 25.009 147.556C25.009 150.7 22.4601 153.249 19.3159 153.249Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.72518
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_2",
    x: 0,
    y: 0.0447998,
    width: 135.158,
    height: 136.386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2871
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.623529 0 0 0 0 0.956863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1_2",
    x: 93.3851,
    y: 49.2024,
    width: 24.0773,
    height: 6.96255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1_2",
    x: 93.3851,
    y: 63.4117,
    width: 27.6368,
    height: 6.97705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1_2",
    x: 93.3934,
    y: 56.2701,
    width: 35.0958,
    height: 7.00742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1_2",
    x: 42.6153,
    y: 14.6898,
    width: 39.6296,
    height: 5.46736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1_2",
    x: 42.6305,
    y: 9.94924,
    width: 59.5906,
    height: 5.49726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1_2",
    x: 31.9592,
    y: 9.93766,
    width: 12.9755,
    height: 10.1601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.854902 0 0 0 0 0.545098 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_1_2",
    x: 25.8022,
    y: 43.5176,
    width: 79.103,
    height: 125.466,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.12678
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.31695
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_1_2",
    x: 42.6875,
    y: 70.0805,
    width: 66.2054,
    height: 96.776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: -3.68612
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.91483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.811438 0 0 0 0 0.157674 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_1_2",
    x: 41.7754,
    y: 109.069,
    width: 28.7569,
    height: 57.3148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: -3.68612
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.91483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.811438 0 0 0 0 0.157674 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_1_2",
    x: 25.8022,
    y: 43.5176,
    width: 79.103,
    height: 92.7222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.12678
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.31695
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_1_2",
    x: 25.8022,
    y: 43.5176,
    width: 84.0179,
    height: 93.0528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.811438 0 0 0 0 0.157674 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_1_2",
    x: 69.512,
    y: 81.6123,
    width: 15.3704,
    height: 8.76187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_1_2",
    x: 48.9906,
    y: 82.5572,
    width: 15.819,
    height: 7.84461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_1_2",
    x: 63.1475,
    y: 85.0534,
    width: 8.60093,
    height: 5.61061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_1_2",
    x: 63.1475,
    y: 92.4254,
    width: 8.60093,
    height: 5.61062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_1_2",
    x: 63.1475,
    y: 99.7569,
    width: 8.60093,
    height: 4.55422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_1_2",
    x: 63.1475,
    y: 105.942,
    width: 8.60093,
    height: 5.61068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_1_2",
    x: 63.1475,
    y: 112.086,
    width: 8.60093,
    height: 5.61056,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_1_2",
    x: 63.1475,
    y: 88.74,
    width: 8.60093,
    height: 5.61065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_1_2",
    x: 63.1475,
    y: 96.112,
    width: 8.60093,
    height: 5.61061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_1_2",
    x: 63.1475,
    y: 102.255,
    width: 8.60093,
    height: 5.61093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_1_2",
    x: 63.1475,
    y: 109.586,
    width: 8.60093,
    height: 4.55412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.283782 0 0 0 0 0.209028 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_i_1_2",
    x: 144.653,
    y: 103.256,
    width: 9.82966,
    height: 63.8927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.545098 0 0 0 0 0.560784 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_i_1_2",
    x: 118.518,
    y: 74.11,
    width: 58.8479,
    height: 33.397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.545098 0 0 0 0 0.560784 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_i_1_2",
    x: 124.301,
    y: 78.0409,
    width: 48.0588,
    height: 25.5345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.91483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.623529 0 0 0 0 0.956863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_i_1_2",
    x: 129.908,
    y: 161.005,
    width: 39.3188,
    height: 6.1434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: 2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.545098 0 0 0 0 0.560784 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_i_1_2",
    x: 153.764,
    y: 47.8496,
    width: 87.2362,
    height: 120.632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.12678
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.31695
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_i_1_2",
    x: 207.968,
    y: 74.529,
    width: 25.07,
    height: 46.4562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: -3.68612
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.91483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.811438 0 0 0 0 0.157674 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_i_1_2",
    x: 178.798,
    y: 108.568,
    width: 28.7565,
    height: 57.3148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: -3.68612
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.91483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.811438 0 0 0 0 0.157674 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_i_1_2",
    x: 153.764,
    y: 79.4714,
    width: 53.4591,
    height: 21.603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: -3.68612
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.91483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.811438 0 0 0 0 0.157674 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_i_1_2",
    x: 179.709,
    y: 69.5783,
    width: 66.2054,
    height: 96.7762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: -3.68612
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.97542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.811438 0 0 0 0 0.157674 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_ii_1_2",
    x: 174.577,
    y: 44.1635,
    width: 48.2374,
    height: 49.1354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.12678
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.1022
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: -3.68612
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.38034
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.811438 0 0 0 0 0.157674 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1_2",
    result: "effect2_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_i_1_2",
    x: 174.489,
    y: 59.033,
    width: 29.7076,
    height: 25.7116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.91483,
    dy: -2.45741
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.52918
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.623529 0 0 0 0 0.956863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_i_1_2",
    x: 224.5,
    y: 36.3568,
    width: 17.4244,
    height: 14.8366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.31296,
    dy: 1.72518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15648
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.854902 0 0 0 0 0.545098 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_i_1_2",
    x: 12.7602,
    y: 141,
    width: 17.4244,
    height: 14.8366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.31296,
    dy: 1.72518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.60046
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.278431 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTopicSerpxray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/topic-serpxray.9088198e92df67c35ffaca2300827e74.svg";